/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * PerForma API
 * OpenAPI spec version: v1
 */
import {
  HttpClient,
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import {
  Observable
} from 'rxjs';


// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export interface APCheckDocumentTypeDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
}

export interface APCheckSignatureDto {
  SignatureNumber?: number;
  /** @nullable */
  SignatureName?: string | null;
  /** @nullable */
  SignatureImage?: string | null;
  /** @nullable */
  DisplayImage?: string | null;
}

export interface APCheckPrintPreviewDto {
  /** @nullable */
  TopMargin?: string | null;
  /** @nullable */
  LeftMargin?: string | null;
  /** @nullable */
  Height?: string | null;
  /** @nullable */
  Width?: string | null;
}

export interface APCheckDto {
  UserIsAdmin?: boolean;
  UsesBankAccount?: boolean;
  IsCanadian?: boolean;
  /** @nullable */
  BankAccounts?: string[] | null;
  /** @nullable */
  Signatures?: APCheckSignatureDto[] | null;
  DualSignatureThreshold?: number;
  PrintPreview?: APCheckPrintPreviewDto;
}

export interface APCheckKeywordDto {
  Id?: number;
  DocumentTypeId?: number;
  /** @nullable */
  Name?: string | null;
}

export interface APCheckLogSearchDto {
  PageIndex?: number;
  PageSize?: number;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  StartDate?: string | null;
  /** @nullable */
  EndDate?: string | null;
  /** @nullable */
  LogType?: number | null;
  /** @nullable */
  SearchField?: string | null;
  /** @nullable */
  SearchValue?: string | null;
}

export interface APCheckPrintLogDto {
  LogId?: number;
  LogDate?: string;
  /** @nullable */
  UserName?: string | null;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  Info?: string | null;
  LogType?: number;
}

export interface APCheckLogSearchResultDto {
  /** @nullable */
  Data?: APCheckPrintLogDto[] | null;
  Total?: number;
}

export interface APCheckPrintRequestDto {
  /** @nullable */
  BankAccountNumber?: number | null;
  FirstCheckNumber?: number;
  LastCheckNumber?: number;
  ValidateOnly?: boolean;
}

export interface APCheckPrintResponseDto {
  Success?: boolean;
  /** @nullable */
  TaskId?: string | null;
  /** @nullable */
  ErrorMessage?: string | null;
}

export interface APCheckPrintStatusRequestDto {
  /** @nullable */
  TaskId?: string | null;
}

export interface APCheckPrintStatusResponseDto {
  /** @nullable */
  Status?: string | null;
  IsComplete?: boolean;
  HasError?: boolean;
  /** @nullable */
  ErrorMessage?: string | null;
  /** @nullable */
  DoneFile?: string | null;
  ValidateOnly?: boolean;
  BankAccountNumber?: number;
  FirstCheckNumber?: number;
  LastCheckNumber?: number;
}

export interface APCheckSignatureInfoDto {
  X?: number;
  Y?: number;
  Height?: number;
  Width?: number;
}

export interface APCheckSettingsDto {
  UsesBankAccount?: boolean;
  IsCanadian?: boolean;
  DocumentType?: APCheckDocumentTypeDto;
  BankAccountKeyword?: APCheckKeywordDto;
  CheckNumberKeyword?: APCheckKeywordDto;
  AmountKeyword?: APCheckKeywordDto;
  DualSignatureThreshold?: number;
  PrimarySignatureInfo?: APCheckSignatureInfoDto;
  SecondarySignatureInfo?: APCheckSignatureInfoDto;
  CheckOrderAscending?: boolean;
  DeleteStampedChecks?: boolean;
}

export interface ARReportCustomerDto {
  CustomerID?: number;
  /**
     * @maxLength 255
     * @nullable
     */
  CustomerNumber?: string | null;
  /**
     * @maxLength 255
     * @nullable
     */
  CustomerName?: string | null;
  /**
     * @maxLength 255
     * @nullable
     */
  EmailAddress?: string | null;
  ShouldPrint?: boolean;
  ShouldEmail?: boolean;
}

export interface ARReportCustomerExportSearchDto {
  /** @nullable */
  PageIndex?: number | null;
  /** @nullable */
  PageSize?: number | null;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  SearchField?: string | null;
  /** @nullable */
  SearchValue?: string | null;
}

export interface ARReportCustomerSearchDto {
  PageIndex?: number;
  PageSize?: number;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  SearchField?: string | null;
  /** @nullable */
  SearchValue?: string | null;
}

export interface ARReportCustomerSearchResultDto {
  /** @nullable */
  Data?: ARReportCustomerDto[] | null;
  Total?: number;
}

export interface UserPrinterDto {
  PrinterID?: number;
  /** @nullable */
  PrinterName?: string | null;
  Default?: boolean;
}

export interface ARReportInfoDto {
  /** @nullable */
  Printers?: UserPrinterDto[] | null;
  /** @nullable */
  EmailSubject?: string | null;
  /** @nullable */
  EmailBody?: string | null;
  /** @nullable */
  EmailFrom?: string | null;
}

export interface ARReportJobParams {
  /** @nullable */
  MinCustomerNumber?: string | null;
  /** @nullable */
  MaxCustomerNumber?: string | null;
  /** @nullable */
  CustomerNumber?: string | null;
  /** @nullable */
  StatementDate?: string | null;
  Copies?: number;
  Email?: boolean;
  /** @nullable */
  EmailSubject?: string | null;
  /** @nullable */
  EmailBody?: string | null;
  /** @nullable */
  EmailFrom?: string | null;
  /** @nullable */
  Printer?: string | null;
  /** @nullable */
  InstanceGuid?: string | null;
}

export interface ARReportStatusDto {
  ReportDone?: boolean;
  /** @nullable */
  ReportDate?: string | null;
  /** @nullable */
  StatusText?: string | null;
  /** @nullable */
  ReportType?: string | null;
  DocumentsDone?: number;
  DocumentsTodo?: number;
}

export interface AccessTokenResponse {
  /** @nullable */
  readonly TokenType?: string | null;
  /** @nullable */
  AccessToken: string | null;
  ExpiresIn: number;
  /** @nullable */
  RefreshToken: string | null;
}

export interface AiHintDto {
  Id?: number;
  /** @nullable */
  Hint?: string | null;
}

export type SearchType = typeof SearchType[keyof typeof SearchType];


export const SearchType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export interface SearchRequestKeywordDto {
  /** @nullable */
  Id?: number | null;
  Operator?: SearchType;
  /** @nullable */
  Value?: string | null;
}

export interface BulkRequestDto {
  /** @nullable */
  PreviousQuery?: string | null;
  /** @nullable */
  PreviousFriendlyQuery?: string | null;
  /** @nullable */
  FullText?: string | null;
  /** @nullable */
  Keywords?: SearchRequestKeywordDto[] | null;
  /** @nullable */
  DocumentTypes?: number[] | null;
  /** @nullable */
  ArchiveDate?: string | null;
  ArchiveDateOperator?: SearchType;
  /** @nullable */
  EmailSubject?: string | null;
  /** @nullable */
  EmailTo?: string | null;
  /** @nullable */
  EmailBody?: string | null;
  Selected?: boolean;
  /** @nullable */
  Selection?: number[] | null;
  Total?: number;
}

export interface ChangeEmailRequest {
  /** @nullable */
  Email?: string | null;
}

export interface ChangePasswordRequest {
  /** @nullable */
  CurrentPassword?: string | null;
  /** @nullable */
  NewPassword?: string | null;
}

export interface ConsentFormDto {
  FormID?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Description?: string | null;
  LogoutOnDecline?: boolean;
  /** @nullable */
  TemplateHTML?: string | null;
  /** @nullable */
  ExpiresInDays?: number | null;
  Version?: number;
}

export interface DXSettingsDto {
  FOConnector?: boolean;
  /** @nullable */
  DataExchangeBaseURL?: string | null;
  /** @nullable */
  DataExchangeAPIVersion?: string | null;
  /** @nullable */
  DataExchangeAPIKey?: string | null;
}

export interface SearchDocumentTypeDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
}

export interface SearchFileDto {
  Id?: number;
  /** @nullable */
  MimeType?: string | null;
  /** @nullable */
  Extension?: string | null;
  Original?: boolean;
  /** @nullable */
  FileType?: string | null;
  /** @nullable */
  Url?: string | null;
}

export interface DocumentKeywordDto {
  /** @nullable */
  ID?: number | null;
  DocumentTypeMetaDataDefinitionID?: number;
  MetaDataDefinitionID?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Regex?: string | null;
  /** @nullable */
  DateFormatString?: string | null;
  Required?: boolean;
  KeywordType?: number;
  /** @nullable */
  DateValue?: string | null;
  /** @nullable */
  Value?: string | null;
}

export interface SearchNoteDto {
  /** @nullable */
  ID?: number | null;
  /** @nullable */
  User?: string | null;
  /** @nullable */
  Content?: string | null;
  Timestamp?: string;
}

export interface DocumentDto {
  ID?: number;
  /** @nullable */
  Name?: string | null;
  ArchiveDate?: string;
  DocumentType?: SearchDocumentTypeDto;
  /** @nullable */
  Files?: SearchFileDto[] | null;
  /** @nullable */
  Keywords?: DocumentKeywordDto[] | null;
  /** @nullable */
  Notes?: SearchNoteDto[] | null;
  CanAddNotes?: boolean;
  CanEditKeywordData?: boolean;
}

export interface KeywordSearchField {
  ID?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Regex?: string | null;
  /** @nullable */
  DateFormatString?: string | null;
  Required?: boolean;
  /** @nullable */
  Aliases?: string[] | null;
  /** @nullable */
  KeywordType?: string | null;
}

export interface DocumentType {
  ID?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Aliases?: string[] | null;
  /** @nullable */
  MimeType?: string | null;
  /** @nullable */
  KeywordSearchFields?: KeywordSearchField[] | null;
}

export interface DocumentTypeAliasDto {
  /** @nullable */
  DocumentTypeAliasID?: number | null;
  DocumentTypeID?: number;
  /** @nullable */
  DocumentTypeAliasName?: string | null;
}

export interface FileTypeDto {
  FileTypeID?: number;
  /** @nullable */
  FileTypeName?: string | null;
  /** @nullable */
  FileTypeMimeType?: string | null;
  /** @nullable */
  FileTypeExtention?: string | null;
}

export interface DocumentTypeKeywordDto {
  /** @nullable */
  DocumentTypeMetaDataDefinitionID?: number | null;
  MetaDataDefinitionID?: number;
  DocumentTypeID?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Regex?: string | null;
  RegexIsValid?: boolean;
  /** @nullable */
  DateFormatString?: string | null;
  Required?: boolean;
  DisplayOrder?: number;
  DisplayOnList?: boolean;
  KeywordType?: number;
}

export interface DocumentTypeKeywordAliasDto {
  /** @nullable */
  MetaDataDefinitionAliasID?: number | null;
  MetaDataDefinitionID?: number;
  DocumentTypeID?: number;
  /** @nullable */
  KeywordName?: string | null;
  /**
     * @minLength 0
     * @maxLength 255
     */
  Alias: string;
}

export interface DocumentTypeDto {
  /** @nullable */
  DocumentTypeID?: number | null;
  /** @nullable */
  DocumentTypeName?: string | null;
  /**
     * @minLength 0
     * @maxLength 50
     */
  Alias: string;
  FileType?: FileTypeDto;
  /** @nullable */
  Aliases?: DocumentTypeAliasDto[] | null;
  /** @nullable */
  Keywords?: DocumentTypeKeywordDto[] | null;
  /** @nullable */
  KeywordAliases?: DocumentTypeKeywordAliasDto[] | null;
}

export interface DocumentTypeManageDto {
  DocumentTypeID?: number;
  /** @nullable */
  DocumentTypeName?: string | null;
  /** @nullable */
  FileTypeName?: string | null;
  Aliases?: number;
  Documents?: number;
  Keywords?: number;
  KeywordAliases?: number;
}

export interface DocumentTypeSearchResultDto {
  /** @nullable */
  Data?: DocumentTypeManageDto[] | null;
  Total?: number;
}

export interface EQConnectorKeyDto {
  /** @nullable */
  LastServerName?: string | null;
  /** @nullable */
  LastInstallPath?: string | null;
  /** @nullable */
  LastUniqueKey?: string | null;
  /** @nullable */
  LastLicenseKey?: string | null;
  /** @nullable */
  LastArchivePath?: string | null;
  /** @nullable */
  LastVersion?: string | null;
  /** @nullable */
  LastReportDate?: string | null;
  /** @nullable */
  CurrentUniqueKey?: string | null;
  /** @nullable */
  CurrentLicenseKey?: string | null;
}

export interface EQValidateRequest {
  /** @minLength 1 */
  UniqueID: string;
  /** @minLength 1 */
  LicenseKey: string;
  /** @minLength 1 */
  Version: string;
  /** @minLength 1 */
  ServerName: string;
  /** @nullable */
  ArchivePath?: string | null;
  readonly ArchivePathSpecified?: boolean;
  /** @nullable */
  InstallPath?: string | null;
  readonly InstallPathSpecified?: boolean;
  /** @nullable */
  LastReportDate?: string | null;
  readonly LastReportDateSpecified?: boolean;
  ValidateLicenseOnly?: boolean;
}

export interface EQValidateResultDto {
  Authorized?: boolean;
}

export interface EditZonalPageDto {
  PageID?: number;
  PageNumber?: number;
}

export interface FINAddCustomerRequest {
  /** @nullable */
  InstanceGuid?: string | null;
  /** @nullable */
  CustomerId?: string | null;
}

export interface FINRemoveCustomerRequest {
  /** @nullable */
  InstanceGuid?: string | null;
  /** @nullable */
  CustomerId?: string | null;
}

export interface FINReportInfoDto {
  /** @nullable */
  CustomerList?: string[] | null;
}

export type SnapshotType = typeof SnapshotType[keyof typeof SnapshotType];


export const SnapshotType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;

export interface FINReportJobParams {
  /** @nullable */
  MinCustomerNumber?: number | null;
  /** @nullable */
  MaxCustomerNumber?: number | null;
  /** @nullable */
  CustomerNumber?: number | null;
  RunFromList?: boolean;
  /** @nullable */
  SnapshotTypes?: SnapshotType[] | null;
  /** @nullable */
  StartDate?: string | null;
  /** @nullable */
  EndDate?: string | null;
  /** @nullable */
  InstanceGuid?: string | null;
}

export interface FINReportStatusDto {
  ReportDone?: boolean;
  /** @nullable */
  ReportStartDate?: string | null;
  /** @nullable */
  ReportEndDate?: string | null;
  /** @nullable */
  StatusText?: string | null;
  /** @nullable */
  ReportType?: string | null;
  DocumentsDone?: number;
  DocumentsTodo?: number;
}

export interface FailedZonalTemplateCreateDto {
  ScanDocumentID?: number;
  DocumentTypeID?: number;
  /** @nullable */
  ZonalTemplateName?: string | null;
}

export interface FailedZonalTemplateListItemDto {
  ScanDocumentID?: number;
  ScanTime?: string;
}

export interface ForgotPasswordRequest {
  /** @nullable */
  Email: string | null;
}

export interface GroupAndUserDocumentPermissionDto {
  UploadFile?: boolean;
  EditKeywordData?: boolean;
  AddNotes?: boolean;
  DeleteDocuments?: boolean;
  PerFormaScan?: boolean;
  DeleteScan?: boolean;
}

export interface GroupDepartmentDto {
  /** @nullable */
  GroupPTPDepartmentID?: number | null;
  DepartmentID?: number;
  /** @nullable */
  DepartmentName?: string | null;
}

export interface GroupDocumentTypeDto {
  /** @nullable */
  DocumentTypeGroupSecurityID?: number | null;
  GroupID?: number;
  DocumentTypeID?: number;
  /** @nullable */
  DocumentTypeName?: string | null;
  DocumentPermissions?: GroupAndUserDocumentPermissionDto;
}

export interface GroupPermissionsDto {
  PerFormaAdmin?: boolean;
  PerFormaScanAdmin?: boolean;
  APCheckAdmin?: boolean;
  APCheckUser?: boolean;
  ARReportUser?: boolean;
  FINReportUser?: boolean;
  PTPSystemCEO?: boolean;
  PTPStoreManager?: boolean;
}

export interface GroupUserDto {
  /** @nullable */
  UserGroupID?: number | null;
  UserID?: number;
  /** @nullable */
  UserName?: string | null;
  /** @nullable */
  Email?: string | null;
}

export interface GroupLocationDto {
  /** @nullable */
  GroupPTPLocationID?: number | null;
  LocationID?: number;
  /** @nullable */
  LocationName?: string | null;
}

export interface GroupStepDto {
  StepID?: number;
  /** @nullable */
  StepName?: string | null;
  StepType?: number;
  IsReadOnly?: boolean;
  /** @nullable */
  GroupID?: number | null;
}

export interface GroupFormDto {
  FormID?: number;
  /** @nullable */
  FormName?: string | null;
  FormType?: number;
  IsReadOnly?: boolean;
  /** @nullable */
  GroupID?: number | null;
}

export interface GroupDto {
  GroupID?: number;
  /** @nullable */
  GroupName?: string | null;
  Permissions?: GroupPermissionsDto;
  /** @nullable */
  Users?: GroupUserDto[] | null;
  /** @nullable */
  Locations?: GroupLocationDto[] | null;
  /** @nullable */
  Departments?: GroupDepartmentDto[] | null;
  /** @nullable */
  Steps?: GroupStepDto[] | null;
  /** @nullable */
  Forms?: GroupFormDto[] | null;
  /** @nullable */
  DocumentTypes?: GroupDocumentTypeDto[] | null;
}

export interface GroupManageDto {
  GroupID?: number;
  /** @nullable */
  GroupName?: string | null;
  Users?: number;
  PerFormaAdmin?: boolean;
  PerFormaScanAdmin?: boolean;
  APCheckAdmin?: boolean;
  APCheckUser?: boolean;
  ARReportUser?: boolean;
  FINReportUser?: boolean;
  PTPSystemCEO?: boolean;
  PTPStoreManager?: boolean;
}

export interface GroupSearchResultDto {
  /** @nullable */
  Data?: GroupManageDto[] | null;
  Total?: number;
}

/**
 * @nullable
 */
export type HttpValidationProblemDetailsErrors = {[key: string]: string[]} | null;

export interface HttpValidationProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  errors?: HttpValidationProblemDetailsErrors;
  [key: string]: unknown;
}

export type KeywordType = typeof KeywordType[keyof typeof KeywordType];


export const KeywordType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface IntegrationMetadataDto {
  Id?: number;
  KeywordId?: number;
  KeywordType?: KeywordType;
  /** @nullable */
  Value?: string | null;
}

export interface IntegrationNoteDto {
  Id?: number;
  Timestamp?: string;
  /** @nullable */
  UserName?: string | null;
  /** @nullable */
  Note?: string | null;
}

export interface IntegrationFileDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  MimeType?: string | null;
  /** @nullable */
  Extension?: string | null;
}

export interface IntegrationDocumentDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
  ArchiveDate?: string;
  /** @nullable */
  Metadata?: IntegrationMetadataDto[] | null;
  /** @nullable */
  Notes?: IntegrationNoteDto[] | null;
  DocumentTypeId?: number;
  /** @nullable */
  DocumentTypeName?: string | null;
  /** @nullable */
  Files?: IntegrationFileDto[] | null;
}

export type IntegrationOperator = typeof IntegrationOperator[keyof typeof IntegrationOperator];


export const IntegrationOperator = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export interface IntegrationParamDto {
  Id?: number;
  Operator?: SearchType;
  /** @nullable */
  Criteria?: string | null;
}

export interface IntegrationSearchDto {
  /** @nullable */
  DocumentTypes?: number[] | null;
  /** @nullable */
  DocumentIds?: number[] | null;
  Size?: number;
  Start?: number;
  /** @nullable */
  Params?: IntegrationParamDto[] | null;
  /** @nullable */
  ArchiveDate?: string | null;
  ArchiveDateOperator?: IntegrationOperator;
}

export interface IntegrationSearchResponseDto {
  /** @nullable */
  Documents?: IntegrationDocumentDto[] | null;
  Total?: number;
}

export interface InternalSettingDto {
  KeyID?: number;
  /** @nullable */
  KeyName?: string | null;
  /** @nullable */
  KeyValue?: string | null;
  IsBoolean?: boolean;
  BoolValue?: boolean;
}

export interface JobCreateResponse {
  readonly Success?: boolean;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  JobGuid?: string | null;
}

export type PFJobType = typeof PFJobType[keyof typeof PFJobType];


export const PFJobType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export interface JobItemDto {
  JobID?: number;
  /** @nullable */
  JobUniqueID?: string | null;
  JobParams?: unknown;
  RetryCount?: number;
  /** @nullable */
  JobCompleteFile?: string | null;
  JobType?: PFJobType;
  JobCompleted?: boolean;
  /** @nullable */
  JobStatus?: string | null;
  /** @nullable */
  JobCreateTime?: string | null;
  /** @nullable */
  JobStartTime?: string | null;
  /** @nullable */
  JobEndTime?: string | null;
  /** @nullable */
  FileName?: string | null;
}

export interface JobQueryDto {
  Page?: number;
  PageSize?: number;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  JobTypeFilter?: string[] | null;
  /** @nullable */
  StatusFilter?: string[] | null;
  /** @nullable */
  SearchValue?: string | null;
}

export interface JobsListDto {
  /** @nullable */
  Jobs?: JobItemDto[] | null;
  Page?: number;
  PageSize?: number;
  TotalPages?: number;
  TotalItems?: number;
}

export interface SchemaKeywordDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Regex?: string | null;
  /** @nullable */
  DateFormat?: string | null;
  KeywordType?: KeywordType;
  InUse?: boolean;
}

export interface KeywordSearchResultDto {
  /** @nullable */
  Data?: SchemaKeywordDto[] | null;
  Total?: number;
}

export interface LogDto {
  ID?: number;
  Date?: string;
  /** @nullable */
  Hostname?: string | null;
  /** @nullable */
  Thread?: string | null;
  /** @nullable */
  Level?: string | null;
  /** @nullable */
  Logger?: string | null;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  Exception?: string | null;
}

export interface LogSearchResultDto {
  /** @nullable */
  Data?: LogDto[] | null;
  Total?: number;
}

export interface LoginRequest {
  /** @nullable */
  Email: string | null;
  /** @nullable */
  Password: string | null;
  /** @nullable */
  TwoFactorCode?: string | null;
  /** @nullable */
  TwoFactorRecoveryCode?: string | null;
}

export interface ManageIndexInfoDto {
  Reindexing?: boolean;
  Documents?: number;
  SolrDocuments?: number;
  IndexedDocuments?: number;
  /** @nullable */
  Status?: string | null;
  PercentComplete?: number;
}

export interface MetaDataDefinitionOptionDto {
  MetaDataDefinitionID?: number;
  /** @nullable */
  MetaDataDefinitionName?: string | null;
}

export interface ModuleDto {
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  DisplayName?: string | null;
  IsEnabled?: boolean;
}

export interface MonitorInfoDto {
  /** @nullable */
  ConnectionString?: string | null;
}

export type PFInstanceAiStatus = typeof PFInstanceAiStatus[keyof typeof PFInstanceAiStatus];


export const PFInstanceAiStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type PTPAccessLevelDto = typeof PTPAccessLevelDto[keyof typeof PTPAccessLevelDto];


export const PTPAccessLevelDto = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;

export interface PTPChartDataDto {
  /** @nullable */
  Labels?: string[] | null;
  /** @nullable */
  Data?: number[] | null;
}

export interface PTPDepartmentDto {
  DepartmentID?: number;
  /** @nullable */
  DepartmentName?: string | null;
}

export interface PTPShippingLocationDto {
  PTPShippingLocationID?: number;
  /** @nullable */
  ShippingLocation?: string | null;
  /** @nullable */
  ShipToAddressLine1?: string | null;
  /** @nullable */
  ShipToAddressLine2?: string | null;
  /** @nullable */
  ShipToCity?: string | null;
  /** @nullable */
  ShipToState?: string | null;
  /** @nullable */
  ShipToZip?: string | null;
  /** @nullable */
  ShipToCountry?: string | null;
  /** @nullable */
  ShipToPhone?: string | null;
  /** @nullable */
  ShipToEmail?: string | null;
  /** @nullable */
  ShipToFax?: string | null;
}

export interface PTPDeptsAndLocationsDto {
  /** @nullable */
  Departments?: PTPDepartmentDto[] | null;
  /** @nullable */
  Locations?: PTPShippingLocationDto[] | null;
}

export type PTPItemTypeDto = typeof PTPItemTypeDto[keyof typeof PTPItemTypeDto];


export const PTPItemTypeDto = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface PTPFormDto {
  FormID?: number;
  /** @nullable */
  FormName?: string | null;
  /** @nullable */
  FormPath?: string | null;
  FormType?: PTPItemTypeDto;
  Order?: number;
  AccessLevel?: PTPAccessLevelDto;
}

export interface PTPHistoryDTO {
  ID?: number;
  /** @nullable */
  Transaction?: string | null;
  HistoryTime?: string;
}

export interface PTPLocationDto {
  PTPShippingLocationID?: number;
  /** @nullable */
  ShippingLocation?: string | null;
  /** @nullable */
  ShipToAddressLine1?: string | null;
  /** @nullable */
  ShipToAddressLine2?: string | null;
  /** @nullable */
  ShipToCity?: string | null;
  /** @nullable */
  ShipToState?: string | null;
  /** @nullable */
  ShipToZip?: string | null;
  /** @nullable */
  ShipToCountry?: string | null;
  /** @nullable */
  ShipToPhone?: string | null;
  /** @nullable */
  ShipToEmail?: string | null;
  /** @nullable */
  ShipToFax?: string | null;
}

export interface PTPMetaDataMapDto {
  PTPMetaDataMapID?: number;
  MetaDataDefinitionID?: number;
  /** @nullable */
  MetaDataDefinitionName?: string | null;
  /** @nullable */
  ColumnName?: string | null;
}

export interface PTPMetaDataMapOptionsDto {
  /** @nullable */
  MetaDataDefinitions?: MetaDataDefinitionOptionDto[] | null;
  /** @nullable */
  POFieldNames?: string[] | null;
}

export interface PTPNoteDto {
  ID?: number;
  /** @nullable */
  Note?: string | null;
  /** @nullable */
  UserName?: string | null;
  NoteTime?: string;
}

export interface PTPPoDocumentMetadataDto {
  /** @nullable */
  FieldName?: string | null;
  /** @nullable */
  FieldValue?: string | null;
}

export interface PTPPoAttachedDocumentDto {
  /** @nullable */
  DocumentTypeName?: string | null;
  DocumentFileID?: number;
  DocumentID?: number;
  DocumentArchiveDate?: string;
  /** @nullable */
  DocumentName?: string | null;
  /** @nullable */
  Metadatas?: PTPPoDocumentMetadataDto[] | null;
}

export interface PTPPoContactDto {
  /** @nullable */
  ContactAddressLine1?: string | null;
  /** @nullable */
  ContactAddressLine2?: string | null;
  /** @nullable */
  ContactCity?: string | null;
  /** @nullable */
  ContactState?: string | null;
  /** @nullable */
  ContactZip?: string | null;
  /** @nullable */
  ContactCountry?: string | null;
  /** @nullable */
  ContactPhone?: string | null;
  /** @nullable */
  ContactEmail?: string | null;
  /** @nullable */
  ContactFax?: string | null;
  /** @nullable */
  ShipToAddressLine1?: string | null;
  /** @nullable */
  ShipToAddressLine2?: string | null;
  /** @nullable */
  ShipToCity?: string | null;
  /** @nullable */
  ShipToState?: string | null;
  /** @nullable */
  ShipToZip?: string | null;
  /** @nullable */
  ShipToCountry?: string | null;
  /** @nullable */
  ShipToPhone?: string | null;
  /** @nullable */
  ShipToEmail?: string | null;
  /** @nullable */
  ShipToFax?: string | null;
}

export interface PTPPoLineItemDto {
  ID?: number;
  /** @nullable */
  Description?: string | null;
  Quantity?: number;
  Price?: number;
  Received?: number;
}

export interface PTPUserDto {
  UserID?: number;
  /** @nullable */
  UserName?: string | null;
}

export interface PTPPoRequestLineItemDto {
  ID?: number;
  /** @nullable */
  Description?: string | null;
  Quantity?: number;
  Price?: number;
}

export interface PTPPoRequestAttachmentDto {
  PurchaseRequestAttachmentID?: number;
  /** @nullable */
  FileName?: string | null;
  /** @nullable */
  Description?: string | null;
}

export interface PTPPoRequestDto {
  PORequestID?: number;
  /** @nullable */
  LineItems?: PTPPoRequestLineItemDto[] | null;
  /** @nullable */
  Notes?: PTPNoteDto[] | null;
  /** @nullable */
  Transactions?: PTPHistoryDTO[] | null;
  CreatedBy?: PTPUserDto;
  CreateDate?: string;
  DenyVisible?: boolean;
  /** @nullable */
  VendorName?: string | null;
  /** @nullable */
  VendorContact?: string | null;
  /** @nullable */
  VendorNumber?: string | null;
  /** @nullable */
  NeedNotes?: string | null;
  /** @nullable */
  NeedReasonNotes?: string | null;
  /** @nullable */
  ShipToAddress1?: string | null;
  /** @nullable */
  ShipToAddress2?: string | null;
  /** @nullable */
  ShipToCity?: string | null;
  /** @nullable */
  ShipToState?: string | null;
  /** @nullable */
  ShipToZip?: string | null;
  /** @nullable */
  ShipToCountry?: string | null;
  /** @nullable */
  ShipToPhone?: string | null;
  /** @nullable */
  ShipToEmail?: string | null;
  /** @nullable */
  ShipToFax?: string | null;
  Canceled?: boolean;
  Complete?: boolean;
  Department?: number;
  Location?: number;
  /** @nullable */
  Attachments?: PTPPoRequestAttachmentDto[] | null;
  ItemType?: PTPItemTypeDto;
  readonly ItemID?: number;
  StepID?: number;
}

export interface PTPPoDto {
  POID?: number;
  /** @nullable */
  PONumber?: string | null;
  /** @nullable */
  LineItems?: PTPPoLineItemDto[] | null;
  /** @nullable */
  Notes?: PTPNoteDto[] | null;
  /** @nullable */
  Transactions?: PTPHistoryDTO[] | null;
  CreatedBy?: PTPUserDto;
  CreateDate?: string;
  /** @nullable */
  VendorName?: string | null;
  ApproveVisible?: boolean;
  DenyVisible?: boolean;
  /** @nullable */
  VendorContact?: string | null;
  /** @nullable */
  VendorNumber?: string | null;
  /** @nullable */
  VendorInvoiceNumber?: string | null;
  ContactInformation?: PTPPoContactDto;
  PurchaseRequest?: PTPPoRequestDto;
  Department?: number;
  Location?: number;
  StepID?: number;
  ItemType?: PTPItemTypeDto;
  readonly ItemID?: number;
}

export interface PTPPoGoodsReceipt {
  POID?: number;
  /** @nullable */
  ReceiptNotes?: string | null;
  /** @nullable */
  DBSPONumber?: string | null;
  /** @nullable */
  LineItems?: PTPPoLineItemDto[] | null;
  ContactInformation?: PTPPoContactDto;
}

export interface PTPPoTracking {
  TrackingID?: number;
  /** @nullable */
  ShippedVia?: string | null;
  /** @nullable */
  TrackingNumber?: string | null;
}

export interface PTPPoOrderMonitor {
  POID?: number;
  /** @nullable */
  TrackingNotes?: string | null;
  /** @nullable */
  Trackings?: PTPPoTracking[] | null;
  ContactInformation?: PTPPoContactDto;
}

export interface PTPPoPaymentDto {
  POID?: number;
  /** @nullable */
  VendorInvoiceNumber?: string | null;
  /** @nullable */
  PaymentDate?: string | null;
  /** @nullable */
  DueDate?: string | null;
  Reconciled?: boolean;
  /** @nullable */
  PaymentNotes?: string | null;
  /** @nullable */
  CheckNumber?: string | null;
  /** @nullable */
  LineItems?: PTPPoLineItemDto[] | null;
  /** @nullable */
  AttachedDocuments?: PTPPoAttachedDocumentDto[] | null;
}

export interface PTPStepConfigDto {
  StepID?: number;
  /** @nullable */
  StepName?: string | null;
  StepType?: number;
  Order?: number;
  ShowCreate?: boolean;
  /** @nullable */
  DollarAmount?: number | null;
}

export interface PTPStepDto {
  StepID?: number;
  /** @nullable */
  StepName?: string | null;
  StepType?: PTPItemTypeDto;
  Order?: number;
  ShowCreate?: boolean;
  AccessLevel?: PTPAccessLevelDto;
}

export type PTPStepSearchTypeDto = typeof PTPStepSearchTypeDto[keyof typeof PTPStepSearchTypeDto];


export const PTPStepSearchTypeDto = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;

export interface PTPStepSearchDto {
  /** @nullable */
  SearchOption?: string | null;
  SearchType?: PTPStepSearchTypeDto;
  /** @nullable */
  SearchValue?: string | null;
}

export interface PTPStepQueryFilterDto {
  FieldName?: PTPStepSearchDto;
  /** @nullable */
  FieldValue?: string | null;
}

export interface PTPStepQueryDto {
  Page?: number;
  PageSize?: number;
  TotalPages?: number;
  StepID?: number;
  /** @nullable */
  Operator?: string | null;
  FieldName?: PTPStepSearchDto;
  /** @nullable */
  FieldValue?: string | null;
  /** @nullable */
  OrderBy?: string | null;
  IncludeCanceled?: boolean;
  /** @nullable */
  Filters?: PTPStepQueryFilterDto[] | null;
}

export interface PTPStepQueryResultDto {
  Page?: number;
  PageSize?: number;
  TotalPages?: number;
  TotalItems?: number;
  StepID?: number;
  /** @nullable */
  Operator?: string | null;
  /** @nullable */
  FieldName?: string | null;
  /** @nullable */
  FieldValue?: string | null;
  /** @nullable */
  OrderBy?: string | null;
  /** @nullable */
  Items?: unknown[] | null;
}

export interface PTPTimeChartDataDto {
  /** @nullable */
  Labels?: string[] | null;
  /** @nullable */
  Data?: number[][] | null;
  /** @nullable */
  Series?: string[] | null;
}

export interface PTPTransactionDto {
  /** @nullable */
  ItemIDs?: number[] | null;
  /** @nullable */
  Reference?: string | null;
  /** @nullable */
  Reference2?: string | null;
}

export interface PTPTransactionResultDto {
  /** @nullable */
  Messages?: string[] | null;
  /** @nullable */
  Errors?: string[] | null;
}

export interface PagingSearchDto {
  PageIndex?: number;
  PageSize?: number;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  SearchField?: string | null;
  /** @nullable */
  SearchValue?: string | null;
}

export interface ProfileResponse {
  ForcePasswordChange?: boolean;
  /** @nullable */
  Username?: string | null;
  /** @nullable */
  Email?: string | null;
  TwoFactorEnabled?: boolean;
  Id?: number;
  Admin?: boolean;
  ScanAdmin?: boolean;
  APCheckAdmin?: boolean;
  APCheckUser?: boolean;
  ARReports?: boolean;
  FINReports?: boolean;
  PTPAdmin?: boolean;
  PTPLocationAdmin?: boolean;
  /** @nullable */
  Groups?: string[] | null;
}

export interface RefreshRequest {
  /** @nullable */
  RefreshToken: string | null;
}

export interface ReportJobLogDto {
  JobID?: number;
  JobLogID?: number;
  /** @nullable */
  JobUniqueID?: string | null;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  Level?: string | null;
  HasFile?: boolean;
}

export interface ResetPasswordRequest {
  /** @nullable */
  Email: string | null;
  /** @nullable */
  ResetCode: string | null;
  /** @nullable */
  NewPassword: string | null;
}

export type SearchSortType = typeof SearchSortType[keyof typeof SearchSortType];


export const SearchSortType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export interface SearchPaginationDto {
  Size?: number;
  Page?: number;
  Sort?: SearchSortType;
}

export interface SaveSearchRequestDto {
  /** @nullable */
  PreviousQuery?: string | null;
  /** @nullable */
  PreviousFriendlyQuery?: string | null;
  /** @nullable */
  FullText?: string | null;
  /** @nullable */
  Keywords?: SearchRequestKeywordDto[] | null;
  Pagination?: SearchPaginationDto;
  /** @nullable */
  DocumentTypes?: number[] | null;
  /** @nullable */
  ArchiveDate?: string | null;
  ArchiveDateOperator?: SearchType;
  /** @nullable */
  Name?: string | null;
  Id?: number;
}

export interface ScanDirectoryDto {
  ScanDirectoryID?: number;
  /** @nullable */
  ScanDirectoryPath?: string | null;
  ScanDocumentType?: number;
  /** @nullable */
  DocumentTypeName?: string | null;
  ScanSetupType?: number;
  /** @nullable */
  AiPrompt?: string | null;
  /** @nullable */
  AiHints?: AiHintDto[] | null;
}

export interface ScanDto {
  ScanID?: number;
  /** @nullable */
  ScanPreviewUrl?: string | null;
  /** @nullable */
  UserLock?: string | null;
  readonly Locked?: boolean;
  /** @nullable */
  DocumentType?: string | null;
  Timestamp?: string;
  ScanStatus?: number;
  CanUnlock?: boolean;
  CanDelete?: boolean;
}

export interface ScanPageIdDto {
  ScanId?: number;
  PageId?: number;
}

export interface ScanProcessPageDto {
  /** @nullable */
  PageNumber?: number | null;
  DocumentNumber?: number;
  ScanPageId?: number;
  /** @nullable */
  DocumentTypeId?: number | null;
  ScanDocumentId?: number;
}

export interface ScanProcessDocumentDto {
  /** @nullable */
  DocumentTypeId?: number | null;
  ScanDocumentId?: number;
  DocumentNumber?: number;
  IsOcrFailed?: boolean;
  /** @nullable */
  Pages?: ScanProcessPageDto[] | null;
}

export interface ScanProcessDto {
  ScanId?: number;
  /** @nullable */
  SelectedPage?: number | null;
  /** @nullable */
  Documents?: ScanProcessDocumentDto[] | null;
  ScanSetupType?: number;
}

export interface ScanProcessFieldDto {
  MetadataId?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Value?: string | null;
  /** @nullable */
  Confidence?: number | null;
  TypeId?: number;
  Required?: boolean;
  /** @nullable */
  DateFormat?: string | null;
}

export interface ScanProcessFinalizeDto {
  ScanId?: number;
  /** @nullable */
  Name?: string | null;
}

export interface ScanZonalTemplateInfoDto {
  /** @nullable */
  Name?: string | null;
  IsOcrFailed?: boolean;
  IsAi?: boolean;
  Id?: number;
}

export interface ScanProcessMetadataDto {
  /** @nullable */
  Fields?: ScanProcessFieldDto[] | null;
  Template?: ScanZonalTemplateInfoDto;
  ScanDocumentId?: number;
}

export interface ScanProcessRegionRequestDto {
  ZonalTemplateId?: number;
  MetadataId?: number;
}

export interface ScanProcessRegionResponseDto {
  /** @nullable */
  MetadataId?: number | null;
  RegionId?: string;
  RegionType?: number;
  RegionWidth?: number;
  RegionHeight?: number;
  RegionX?: number;
  RegionY?: number;
}

export interface ScanProcessRotateRequestDto {
  ScanPageId?: number;
  Angle?: number;
}

/**
 * @nullable
 */
export type ScanProcessUpdateMetadataDtoValues = {[key: string]: string} | null;

export interface ScanProcessUpdateMetadataDto {
  ScanDocumentId?: number;
  /** @nullable */
  Values?: ScanProcessUpdateMetadataDtoValues;
}

export interface ScanProcessUpdatePageDto {
  ScanId?: number;
  NewDocumentNumber?: number;
  /** @nullable */
  NewDocumentTypeId?: number | null;
  /** @nullable */
  NewPageNumber?: number | null;
  CurrentDocumentNumber?: number;
  /** @nullable */
  CurrentPageNumber?: number | null;
  /** @nullable */
  CurrentDocumentTypeId?: number | null;
}

export interface ScanQueryDto {
  Page?: number;
  PageSize?: number;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  DocumentTypeFilter?: string[] | null;
  /** @nullable */
  UserLockFilter?: string[] | null;
  /** @nullable */
  SearchValue?: string | null;
}

export interface ScanReprocessDto {
  ScanId?: number;
  /** @nullable */
  Reason?: string | null;
}

export interface ScanResultsDto {
  Page?: number;
  PageSize?: number;
  TotalPages?: number;
  TotalItems?: number;
  /** @nullable */
  Items?: ScanDto[] | null;
  /** @nullable */
  DocumentTypes?: string[] | null;
  /** @nullable */
  UserLocks?: string[] | null;
}

export interface Schema {
  /** @nullable */
  DocumentTypes?: DocumentType[] | null;
  /** @nullable */
  KeywordSearchFields?: KeywordSearchField[] | null;
}

export interface SchemaKeywordTypeDto {
  Id?: number;
  /** @nullable */
  Regex?: string | null;
  /** @nullable */
  DateFormat?: string | null;
  Required?: boolean;
  Order?: number;
}

export interface SchemaTypeDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  MimeType?: string | null;
  CanAccess?: boolean;
  CanDelete?: boolean;
  CanEdit?: boolean;
  CanAddNotes?: boolean;
  CanUpload?: boolean;
  CanScan?: boolean;
  CanDeleteScan?: boolean;
  /** @nullable */
  Keywords?: SchemaKeywordTypeDto[] | null;
}

export interface SchemaDto {
  /** @nullable */
  Types?: SchemaTypeDto[] | null;
  /** @nullable */
  Keywords?: SchemaKeywordDto[] | null;
}

export interface SearchKeywordDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Value?: string | null;
}

export interface SearchDocumentDto {
  Id?: number;
  /** @nullable */
  Name?: string | null;
  ArchiveDate?: string;
  DocumentType?: SearchDocumentTypeDto;
  /** @nullable */
  Files?: SearchFileDto[] | null;
  /** @nullable */
  Keywords?: SearchKeywordDto[] | null;
  /** @nullable */
  Notes?: SearchNoteDto[] | null;
}

export interface SearchRequestDto {
  /** @nullable */
  PreviousQuery?: string | null;
  /** @nullable */
  PreviousFriendlyQuery?: string | null;
  /** @nullable */
  FullText?: string | null;
  /** @nullable */
  Keywords?: SearchRequestKeywordDto[] | null;
  Pagination?: SearchPaginationDto;
  /** @nullable */
  DocumentTypes?: number[] | null;
  /** @nullable */
  ArchiveDate?: string | null;
  ArchiveDateOperator?: SearchType;
}

export interface SearchResponseDto {
  Page?: number;
  Returned?: number;
  Total?: number;
  /** @nullable */
  Search?: string | null;
  /** @nullable */
  FriendlySearch?: string | null;
  /** @nullable */
  Documents?: SearchDocumentDto[] | null;
}

export interface SessionDto {
  /** @nullable */
  UserName?: string | null;
  /** @nullable */
  Email?: string | null;
  IsAdmin?: boolean;
  IsScanAdmin?: boolean;
  IsAPCheckAdmin?: boolean;
  IsAPCheckUser?: boolean;
  IsARReportUser?: boolean;
  IsFINReportUser?: boolean;
  IsPTPStoreManager?: boolean;
  IsPTPSystemCEO?: boolean;
  CanUpload?: boolean;
  TwoFactorEnabled?: boolean;
  MustChangePass?: boolean;
  MustSetEmail?: boolean;
  /** @nullable */
  PasswordExpiresOn?: string | null;
  NeedsConsent?: boolean;
}

export interface TotpKeyResponse {
  /** @nullable */
  Key?: string | null;
  /** @nullable */
  Qr?: string | null;
}

export interface TotpRequest {
  /** @nullable */
  Code?: string | null;
  Enable?: boolean;
}

export interface TotpResponse {
  Success?: boolean;
}

export interface UploadKeywordDto {
  MetaDataDefinitionID?: number;
  KeywordType?: number;
  /** @nullable */
  Value?: string | null;
}

export interface UploadResultDto {
  Success?: boolean;
  /** @nullable */
  Error?: string | null;
}

export interface UserConsentRequest {
  FormID?: number;
  Accepted?: boolean;
}

export interface UserConsentResponse {
  Logout?: boolean;
  /** @nullable */
  Forms?: ConsentFormDto[] | null;
}

export interface UserDocumentTypeDto {
  /** @nullable */
  DocumentTypeSecurityUniqueID?: number | null;
  DocumentTypeID?: number;
  /** @nullable */
  DocumentTypeName?: string | null;
  DocumentPermissions?: GroupAndUserDocumentPermissionDto;
}

export interface UserPermissionsDto {
  PerFormaAdmin?: boolean;
  PerFormaScanAdmin?: boolean;
  APCheckAdmin?: boolean;
  APCheckUser?: boolean;
  ARReportUser?: boolean;
  FINReportUser?: boolean;
}

export interface UserGroupDto {
  /** @nullable */
  UserGroupID?: number | null;
  UserID?: number;
  GroupID?: number;
  /** @nullable */
  GroupName?: string | null;
}

export interface UserDto {
  UserID?: number;
  /** @nullable */
  UserName?: string | null;
  /** @nullable */
  Email?: string | null;
  TwoFactorEnabled?: boolean;
  /** @nullable */
  UserPassword?: string | null;
  PasswordChanged?: boolean;
  Permissions?: UserPermissionsDto;
  /** @nullable */
  DocumentTypes?: UserDocumentTypeDto[] | null;
  /** @nullable */
  Groups?: UserGroupDto[] | null;
}

export interface UserManageDto {
  UserID?: number;
  /** @nullable */
  UserName?: string | null;
  /** @nullable */
  Email?: string | null;
  TwoFactorEnabled?: boolean;
  PerFormaAdmin?: boolean;
  PerFormaScanAdmin?: boolean;
  APCheckAdmin?: boolean;
  APCheckUser?: boolean;
  ARReportUser?: boolean;
  FINReportUser?: boolean;
  Groups?: number;
  Deleted?: boolean;
}

export interface UserPagingSearchDto {
  PageIndex?: number;
  PageSize?: number;
  /** @nullable */
  SortField?: string | null;
  /** @nullable */
  SortOrder?: string | null;
  /** @nullable */
  SearchField?: string | null;
  /** @nullable */
  SearchValue?: string | null;
  ShowDeleted?: boolean;
}

export interface UserSearchResultDto {
  /** @nullable */
  Data?: UserManageDto[] | null;
  Total?: number;
}

export interface ZonalMetaDataDefinitionDto {
  MetaDataDefinitionID?: number;
  /** @nullable */
  MetaDataDefinitionName?: string | null;
  MetaDataDefinitionTypeID?: number;
}

export interface ZonalMetaDataDefinitionsDto {
  /** @nullable */
  MetaDataDefinitions?: ZonalMetaDataDefinitionDto[] | null;
}

export type ZonalRegionTypeDto = typeof ZonalRegionTypeDto[keyof typeof ZonalRegionTypeDto];


export const ZonalRegionTypeDto = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export interface ZonalRegionDto {
  RegionID?: string;
  RegionX?: number;
  RegionY?: number;
  RegionHeight?: number;
  RegionWidth?: number;
  /** @nullable */
  DocumentTypeID?: number | null;
  /** @nullable */
  MetaDataDefinitionID?: number | null;
  /** @nullable */
  RegionRegexValidation?: boolean | null;
  /** @nullable */
  RegionDateFormat?: string | null;
  RegionType?: ZonalRegionTypeDto;
}

export interface ZonalPageDto {
  ZonalTemplateID?: number;
  ZonalTemplatePageID?: number;
  ZonalPageNumber?: number;
  /** @nullable */
  Regions?: ZonalRegionDto[] | null;
}

export interface ZonalPagesDto {
  /** @nullable */
  Pages?: ZonalPageDto[] | null;
}

export interface ZonalRegionsDto {
  PageID?: number;
  /** @nullable */
  Regions?: ZonalRegionDto[] | null;
}

export interface ZonalTemplateListItemDto {
  ZonalTemplateID?: number;
  /** @nullable */
  ZonalTemplateName?: string | null;
  /** @nullable */
  DocumentTypeName?: string | null;
}

export type GetApiAPCheckGetDoneFileParams = {
jobGuid?: string;
};

export type PostApiAuthLoginParams = {
useCookies?: boolean;
useSessionCookies?: boolean;
};

export type PutApiConfigureEqConnectorKeyUniqueParams = {
keyValue?: string;
};

export type PutApiConfigurePtpStepsIdReorderParams = {
order?: number;
};

export type PostApiConfigureZonalTemplatesBody = {
  zonalTemplateName?: string;
  documentTypeId?: number;
  file?: Blob;
};

export type PostApiConfigureZonalPagesBody = {
  templateId?: number;
  pageNumber?: string;
  file?: Blob;
};

export type GetApiDocumentFileIdParams = {
inline?: boolean;
};

export type GetApiLegacyImportSchemaParams = {
type?: string;
apiKey?: string;
};

export type GetApiSchemaParams = {
type?: string;
apiKey?: string;
};

export type GetApiSchemaAspxParams = {
type?: string;
apiKey?: string;
};

export type GetApiLegacyImportSearchParams = {
apiKey?: string;
dt?: number;
m?: number;
p?: number;
};

export type GetApiDocumentsSearchParams = {
apiKey?: string;
dt?: number;
m?: number;
p?: number;
};

export type GetApiDocumentsSearchAspxParams = {
apiKey?: string;
dt?: number;
m?: number;
p?: number;
};

export type GetApiLegacyImportGetfileParams = {
apiKey?: string;
id?: string;
inline?: string;
};

export type GetApiDocumentsGetfileParams = {
apiKey?: string;
id?: string;
inline?: string;
};

export type GetApiDocumentsGetfileAspxParams = {
apiKey?: string;
id?: string;
inline?: string;
};

export type PostApiLegacyImportUploadParams = {
apiKey?: string;
};

export type PostApiDocumentsUploadParams = {
apiKey?: string;
};

export type PostApiDocumentsUploadAspxParams = {
apiKey?: string;
};

export type GetApiPTPGetFormsParams = {
itemType?: PTPItemTypeDto;
};

export type GetApiPTPGetSearchOptionsParams = {
itemType?: PTPItemTypeDto;
};

export type GetApiPTPGetDepartmentChartParams = {
fromDate?: string;
toDate?: string;
};

export type GetApiPTPGetVendorChartParams = {
fromDate?: string;
toDate?: string;
};

export type GetApiPTPGetDollarsTimeChartParams = {
fromDate?: string;
toDate?: string;
};

export type GetApiPTPGetLocationChartParams = {
fromDate?: string;
toDate?: string;
};

export type GetApiPTPGetApproveChartParams = {
fromDate?: string;
toDate?: string;
};

export type PostApiPTPPOInvoiceBody = {
  file?: Blob;
};

export type PostApiPTPCreatePORequestParams = {
stepId?: number;
};

export type GetApiPTPGetPORequestParams = {
poRequestId?: number;
};

export type PostApiPTPUploadPORequestAttachmentBody = {
  file?: Blob;
  poRequestId?: number;
  fileName?: string;
  fileDescription?: string;
};

export type GetApiPTPGetPORequestAttachmentParams = {
attachmentId?: number;
};

export type GetApiPTPDeletePORequestAttachmentParams = {
attachmentId?: number;
};

export type PostApiPTPCreatePOParams = {
stepId?: number;
};

export type GetApiPTPGetPOParams = {
poId?: number;
};

export type GetApiPTPGetOrderMonitorParams = {
poId?: number;
};

export type GetApiPTPGetGoodsReceiptParams = {
poId?: number;
};

export type GetApiPTPGetPaymentParams = {
poId?: number;
};

export type GetApiScanImageParams = {
scanPageId?: number;
scanId?: number;
large?: boolean;
mini?: boolean;
preview?: boolean;
};

export type GetApiScanProcessSummaryParams = {
scanId?: number;
};

export type GetApiScanProcessMetadataParams = {
scanDocumentId?: number;
};

export type GetApiUploadPurchaseOrderMetadataPoId200 = {[key: string]: string};

export type PostApiUploadDocumentBody = {
  file?: Blob;
  DocumentType?: number;
  PoId?: number;
  Keywords?: UploadKeywordDto[];
};

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (
      preserveRequiredNullables &&
      value === null &&
      requiredNullableKeys.has(key)
    ) {
      filteredParams[key] = null;
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}



export type GetApiScanImageAccept = typeof GetApiScanImageAccept[keyof typeof GetApiScanImageAccept];

export const GetApiScanImageAccept = {
  image_jpeg: 'image/jpeg',
  image_tiff: 'image/tiff',
} as const;

@Injectable({ providedIn: 'root' })
export class PerFormaAPIService {
  private readonly http = inject(HttpClient);
 getApiAccountSession<TData = SessionDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiAccountSession<TData = SessionDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiAccountSession<TData = SessionDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiAccountSession<TData = SessionDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Account/session`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Account/session`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Account/session`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckAPCheckInfo<TData = APCheckDto>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiAPCheckAPCheckInfo<TData = APCheckDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAPCheckAPCheckInfo<TData = APCheckDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAPCheckAPCheckInfo<TData = APCheckDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/APCheck/APCheckInfo`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/APCheck/APCheckInfo`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/APCheck/APCheckInfo`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckUpdateAPCheckSignature<TData = APCheckSignatureDto>(aPCheckSignatureDto?: APCheckSignatureDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAPCheckUpdateAPCheckSignature<TData = APCheckSignatureDto>(aPCheckSignatureDto?: APCheckSignatureDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAPCheckUpdateAPCheckSignature<TData = APCheckSignatureDto>(aPCheckSignatureDto?: APCheckSignatureDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAPCheckUpdateAPCheckSignature<TData = APCheckSignatureDto>(
    aPCheckSignatureDto?: APCheckSignatureDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/APCheck/UpdateAPCheckSignature`,
      aPCheckSignatureDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/APCheck/UpdateAPCheckSignature`,
      aPCheckSignatureDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/APCheck/UpdateAPCheckSignature`,
      aPCheckSignatureDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckPrintOrValidate<TData = APCheckPrintResponseDto>(aPCheckPrintRequestDto?: APCheckPrintRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAPCheckPrintOrValidate<TData = APCheckPrintResponseDto>(aPCheckPrintRequestDto?: APCheckPrintRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAPCheckPrintOrValidate<TData = APCheckPrintResponseDto>(aPCheckPrintRequestDto?: APCheckPrintRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAPCheckPrintOrValidate<TData = APCheckPrintResponseDto>(
    aPCheckPrintRequestDto?: APCheckPrintRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/APCheck/PrintOrValidate`,
      aPCheckPrintRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/APCheck/PrintOrValidate`,
      aPCheckPrintRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/APCheck/PrintOrValidate`,
      aPCheckPrintRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckGetPrintOrValidateStatus<TData = APCheckPrintStatusResponseDto>(aPCheckPrintStatusRequestDto?: APCheckPrintStatusRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAPCheckGetPrintOrValidateStatus<TData = APCheckPrintStatusResponseDto>(aPCheckPrintStatusRequestDto?: APCheckPrintStatusRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAPCheckGetPrintOrValidateStatus<TData = APCheckPrintStatusResponseDto>(aPCheckPrintStatusRequestDto?: APCheckPrintStatusRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAPCheckGetPrintOrValidateStatus<TData = APCheckPrintStatusResponseDto>(
    aPCheckPrintStatusRequestDto?: APCheckPrintStatusRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/APCheck/GetPrintOrValidateStatus`,
      aPCheckPrintStatusRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/APCheck/GetPrintOrValidateStatus`,
      aPCheckPrintStatusRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/APCheck/GetPrintOrValidateStatus`,
      aPCheckPrintStatusRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiAPCheckGetDoneFile<TData = void>(params?: GetApiAPCheckGetDoneFileParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiAPCheckGetDoneFile<TData = void>(params?: GetApiAPCheckGetDoneFileParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiAPCheckGetDoneFile<TData = void>(params?: GetApiAPCheckGetDoneFileParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiAPCheckGetDoneFile<TData = void>(
    params?: GetApiAPCheckGetDoneFileParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/APCheck/GetDoneFile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/APCheck/GetDoneFile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/APCheck/GetDoneFile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiAPCheckGetPreview<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiAPCheckGetPreview<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiAPCheckGetPreview<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiAPCheckGetPreview<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/APCheck/GetPreview`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/APCheck/GetPreview`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/APCheck/GetPreview`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckSearchLogs<TData = APCheckLogSearchResultDto>(aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAPCheckSearchLogs<TData = APCheckLogSearchResultDto>(aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAPCheckSearchLogs<TData = APCheckLogSearchResultDto>(aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAPCheckSearchLogs<TData = APCheckLogSearchResultDto>(
    aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/APCheck/SearchLogs`,
      aPCheckLogSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/APCheck/SearchLogs`,
      aPCheckLogSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/APCheck/SearchLogs`,
      aPCheckLogSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckExportLogs(aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientBodyOptions): Observable<Blob>;
 postApiAPCheckExportLogs(aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 postApiAPCheckExportLogs(aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  postApiAPCheckExportLogs(
    aPCheckLogSearchDto?: APCheckLogSearchDto, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.post(
      `/api/APCheck/ExportLogs`,
      aPCheckLogSearchDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/APCheck/ExportLogs`,
      aPCheckLogSearchDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.post(
      `/api/APCheck/ExportLogs`,
      aPCheckLogSearchDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiAPCheckSettings<TData = APCheckSettingsDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiAPCheckSettings<TData = APCheckSettingsDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiAPCheckSettings<TData = APCheckSettingsDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiAPCheckSettings<TData = APCheckSettingsDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/APCheck/settings`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/APCheck/settings`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/APCheck/settings`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAPCheckSave<TData = void>(aPCheckSettingsDto?: APCheckSettingsDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAPCheckSave<TData = void>(aPCheckSettingsDto?: APCheckSettingsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAPCheckSave<TData = void>(aPCheckSettingsDto?: APCheckSettingsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAPCheckSave<TData = void>(
    aPCheckSettingsDto?: APCheckSettingsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/APCheck/save`,
      aPCheckSettingsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/APCheck/save`,
      aPCheckSettingsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/APCheck/save`,
      aPCheckSettingsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAuthLogin<TData = AccessTokenResponse>(loginRequest?: LoginRequest,
    params?: PostApiAuthLoginParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAuthLogin<TData = AccessTokenResponse>(loginRequest?: LoginRequest,
    params?: PostApiAuthLoginParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAuthLogin<TData = AccessTokenResponse>(loginRequest?: LoginRequest,
    params?: PostApiAuthLoginParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAuthLogin<TData = AccessTokenResponse>(
    loginRequest?: LoginRequest,
    params?: PostApiAuthLoginParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/auth/login`,
      loginRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/auth/login`,
      loginRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/auth/login`,
      loginRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiAuthRefresh<TData = AccessTokenResponse>(refreshRequest?: RefreshRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAuthRefresh<TData = AccessTokenResponse>(refreshRequest?: RefreshRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAuthRefresh<TData = AccessTokenResponse>(refreshRequest?: RefreshRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAuthRefresh<TData = AccessTokenResponse>(
    refreshRequest?: RefreshRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/auth/refresh`,
      refreshRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/auth/refresh`,
      refreshRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/auth/refresh`,
      refreshRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAuthForgotPassword<TData = void>(forgotPasswordRequest?: ForgotPasswordRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAuthForgotPassword<TData = void>(forgotPasswordRequest?: ForgotPasswordRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAuthForgotPassword<TData = void>(forgotPasswordRequest?: ForgotPasswordRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAuthForgotPassword<TData = void>(
    forgotPasswordRequest?: ForgotPasswordRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/auth/forgotPassword`,
      forgotPasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/auth/forgotPassword`,
      forgotPasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/auth/forgotPassword`,
      forgotPasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiAuthResetPassword<TData = void>(resetPasswordRequest?: ResetPasswordRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiAuthResetPassword<TData = void>(resetPasswordRequest?: ResetPasswordRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiAuthResetPassword<TData = void>(resetPasswordRequest?: ResetPasswordRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiAuthResetPassword<TData = void>(
    resetPasswordRequest?: ResetPasswordRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/auth/resetPassword`,
      resetPasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/auth/resetPassword`,
      resetPasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/auth/resetPassword`,
      resetPasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureAiStatus<TData = PFInstanceAiStatus>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureAiStatus<TData = PFInstanceAiStatus>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureAiStatus<TData = PFInstanceAiStatus>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureAiStatus<TData = PFInstanceAiStatus>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ai-status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ai-status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ai-status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureRequestAi<TData = boolean>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureRequestAi<TData = boolean>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureRequestAi<TData = boolean>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureRequestAi<TData = boolean>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/request-ai`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/request-ai`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/request-ai`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureInternalList<TData = InternalSettingDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureInternalList<TData = InternalSettingDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureInternalList<TData = InternalSettingDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureInternalList<TData = InternalSettingDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/internal/list`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/internal/list`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/internal/list`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureInternalId<TData = InternalSettingDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureInternalId<TData = InternalSettingDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureInternalId<TData = InternalSettingDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureInternalId<TData = InternalSettingDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/internal/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/internal/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/internal/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureInternalId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureInternalId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureInternalId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureInternalId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/internal/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/internal/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/internal/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureInternal<TData = InternalSettingDto>(internalSettingDto?: InternalSettingDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureInternal<TData = InternalSettingDto>(internalSettingDto?: InternalSettingDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureInternal<TData = InternalSettingDto>(internalSettingDto?: InternalSettingDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureInternal<TData = InternalSettingDto>(
    internalSettingDto?: InternalSettingDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/internal`,
      internalSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/internal`,
      internalSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/internal`,
      internalSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureInternal<TData = boolean>(internalSettingDto?: InternalSettingDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureInternal<TData = boolean>(internalSettingDto?: InternalSettingDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureInternal<TData = boolean>(internalSettingDto?: InternalSettingDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureInternal<TData = boolean>(
    internalSettingDto?: InternalSettingDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/internal`,
      internalSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/internal`,
      internalSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/internal`,
      internalSettingDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureIndexInfo<TData = ManageIndexInfoDto>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureIndexInfo<TData = ManageIndexInfoDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureIndexInfo<TData = ManageIndexInfoDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureIndexInfo<TData = ManageIndexInfoDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/index/info`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/index/info`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/index/info`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureIndexRebuild<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureIndexRebuild<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureIndexRebuild<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureIndexRebuild<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/index/rebuild`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/index/rebuild`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/index/rebuild`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureDocumentTypesSearch<TData = DocumentTypeSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureDocumentTypesSearch<TData = DocumentTypeSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureDocumentTypesSearch<TData = DocumentTypeSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureDocumentTypesSearch<TData = DocumentTypeSearchResultDto>(
    pagingSearchDto?: PagingSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/document-types/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/document-types/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/document-types/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureDocumentTypesId<TData = DocumentTypeDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureDocumentTypesId<TData = DocumentTypeDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureDocumentTypesId<TData = DocumentTypeDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureDocumentTypesId<TData = DocumentTypeDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/document-types/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/document-types/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/document-types/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureDocumentTypesId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureDocumentTypesId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureDocumentTypesId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureDocumentTypesId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/document-types/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/document-types/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/document-types/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureDocumentTypes<TData = DocumentTypeDto>(documentTypeDto?: DocumentTypeDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureDocumentTypes<TData = DocumentTypeDto>(documentTypeDto?: DocumentTypeDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureDocumentTypes<TData = DocumentTypeDto>(documentTypeDto?: DocumentTypeDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureDocumentTypes<TData = DocumentTypeDto>(
    documentTypeDto?: DocumentTypeDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/document-types`,
      documentTypeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/document-types`,
      documentTypeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/document-types`,
      documentTypeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureDocumentTypes<TData = DocumentTypeDto>(documentTypeDto?: DocumentTypeDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureDocumentTypes<TData = DocumentTypeDto>(documentTypeDto?: DocumentTypeDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureDocumentTypes<TData = DocumentTypeDto>(documentTypeDto?: DocumentTypeDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureDocumentTypes<TData = DocumentTypeDto>(
    documentTypeDto?: DocumentTypeDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/document-types`,
      documentTypeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/document-types`,
      documentTypeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/document-types`,
      documentTypeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureFileTypes<TData = FileTypeDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureFileTypes<TData = FileTypeDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureFileTypes<TData = FileTypeDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureFileTypes<TData = FileTypeDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/file-types`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/file-types`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/file-types`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureEqConnectorKey<TData = EQConnectorKeyDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureEqConnectorKey<TData = EQConnectorKeyDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureEqConnectorKey<TData = EQConnectorKeyDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureEqConnectorKey<TData = EQConnectorKeyDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/eq-connector-key`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/eq-connector-key`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/eq-connector-key`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureEqConnectorKeyUnique<TData = boolean>(params?: PutApiConfigureEqConnectorKeyUniqueParams, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureEqConnectorKeyUnique<TData = boolean>(params?: PutApiConfigureEqConnectorKeyUniqueParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureEqConnectorKeyUnique<TData = boolean>(params?: PutApiConfigureEqConnectorKeyUniqueParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureEqConnectorKeyUnique<TData = boolean>(
    params?: PutApiConfigureEqConnectorKeyUniqueParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/eq-connector-key/unique`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/eq-connector-key/unique`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.put<TData>(
      `/api/Configure/eq-connector-key/unique`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 deleteApiConfigureEqConnectorKeyUnique<TData = boolean>( options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureEqConnectorKeyUnique<TData = boolean>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureEqConnectorKeyUnique<TData = boolean>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureEqConnectorKeyUnique<TData = boolean>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/eq-connector-key/unique`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/eq-connector-key/unique`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/eq-connector-key/unique`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureEqConnectorKeyRegenerate<TData = boolean>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureEqConnectorKeyRegenerate<TData = boolean>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureEqConnectorKeyRegenerate<TData = boolean>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureEqConnectorKeyRegenerate<TData = boolean>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/eq-connector-key/regenerate`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/eq-connector-key/regenerate`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/eq-connector-key/regenerate`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureGroupsAll<TData = GroupSearchResultDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureGroupsAll<TData = GroupSearchResultDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureGroupsAll<TData = GroupSearchResultDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureGroupsAll<TData = GroupSearchResultDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/groups/all`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/groups/all`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/groups/all`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureGroupsSearch<TData = GroupSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureGroupsSearch<TData = GroupSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureGroupsSearch<TData = GroupSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureGroupsSearch<TData = GroupSearchResultDto>(
    pagingSearchDto?: PagingSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/groups/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/groups/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/groups/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureGroupsId<TData = GroupDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureGroupsId<TData = GroupDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureGroupsId<TData = GroupDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureGroupsId<TData = GroupDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/groups/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/groups/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/groups/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureGroupsId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureGroupsId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureGroupsId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureGroupsId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/groups/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/groups/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/groups/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureGroups<TData = GroupDto>(groupDto?: GroupDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureGroups<TData = GroupDto>(groupDto?: GroupDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureGroups<TData = GroupDto>(groupDto?: GroupDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureGroups<TData = GroupDto>(
    groupDto?: GroupDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/groups`,
      groupDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/groups`,
      groupDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/groups`,
      groupDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureGroups<TData = GroupDto>(groupDto?: GroupDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureGroups<TData = GroupDto>(groupDto?: GroupDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureGroups<TData = GroupDto>(groupDto?: GroupDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureGroups<TData = GroupDto>(
    groupDto?: GroupDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/groups`,
      groupDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/groups`,
      groupDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/groups`,
      groupDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureGroupsExport( options?: HttpClientBodyOptions): Observable<Blob>;
 getApiConfigureGroupsExport( options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiConfigureGroupsExport( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiConfigureGroupsExport(
     options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Configure/groups/export`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Configure/groups/export`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Configure/groups/export`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 postApiConfigureKeywordsSearch<TData = KeywordSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureKeywordsSearch<TData = KeywordSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureKeywordsSearch<TData = KeywordSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureKeywordsSearch<TData = KeywordSearchResultDto>(
    pagingSearchDto?: PagingSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/keywords/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/keywords/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/keywords/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureKeywordsId<TData = SchemaKeywordDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureKeywordsId<TData = SchemaKeywordDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureKeywordsId<TData = SchemaKeywordDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureKeywordsId<TData = SchemaKeywordDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/keywords/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/keywords/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/keywords/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureKeywordsId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureKeywordsId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureKeywordsId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureKeywordsId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/keywords/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/keywords/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/keywords/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureKeywordsIdInUse<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureKeywordsIdInUse<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureKeywordsIdInUse<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureKeywordsIdInUse<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/keywords/${id}/in-use`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/keywords/${id}/in-use`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/keywords/${id}/in-use`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureKeywords<TData = SchemaKeywordDto>(schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureKeywords<TData = SchemaKeywordDto>(schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureKeywords<TData = SchemaKeywordDto>(schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureKeywords<TData = SchemaKeywordDto>(
    schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/keywords`,
      schemaKeywordDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/keywords`,
      schemaKeywordDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/keywords`,
      schemaKeywordDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureKeywords<TData = boolean>(schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureKeywords<TData = boolean>(schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureKeywords<TData = boolean>(schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureKeywords<TData = boolean>(
    schemaKeywordDto?: SchemaKeywordDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/keywords`,
      schemaKeywordDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/keywords`,
      schemaKeywordDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/keywords`,
      schemaKeywordDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureLogsSearch<TData = LogSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureLogsSearch<TData = LogSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureLogsSearch<TData = LogSearchResultDto>(pagingSearchDto?: PagingSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureLogsSearch<TData = LogSearchResultDto>(
    pagingSearchDto?: PagingSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/logs/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/logs/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/logs/search`,
      pagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpDepartments<TData = PTPDepartmentDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpDepartments<TData = PTPDepartmentDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpDepartments<TData = PTPDepartmentDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpDepartments<TData = PTPDepartmentDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-departments`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-departments`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-departments`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigurePtpDepartments<TData = PTPDepartmentDto>(pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigurePtpDepartments<TData = PTPDepartmentDto>(pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigurePtpDepartments<TData = PTPDepartmentDto>(pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigurePtpDepartments<TData = PTPDepartmentDto>(
    pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/ptp-departments`,
      pTPDepartmentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/ptp-departments`,
      pTPDepartmentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/ptp-departments`,
      pTPDepartmentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigurePtpDepartments<TData = PTPDepartmentDto>(pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigurePtpDepartments<TData = PTPDepartmentDto>(pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigurePtpDepartments<TData = PTPDepartmentDto>(pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigurePtpDepartments<TData = PTPDepartmentDto>(
    pTPDepartmentDto?: PTPDepartmentDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/ptp-departments`,
      pTPDepartmentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/ptp-departments`,
      pTPDepartmentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/ptp-departments`,
      pTPDepartmentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpDepartmentsId<TData = PTPDepartmentDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpDepartmentsId<TData = PTPDepartmentDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpDepartmentsId<TData = PTPDepartmentDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpDepartmentsId<TData = PTPDepartmentDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-departments/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-departments/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-departments/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigurePtpDepartmentsId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigurePtpDepartmentsId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigurePtpDepartmentsId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigurePtpDepartmentsId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-departments/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-departments/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/ptp-departments/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpLocations<TData = PTPLocationDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpLocations<TData = PTPLocationDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpLocations<TData = PTPLocationDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpLocations<TData = PTPLocationDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-locations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-locations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-locations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigurePtpLocations<TData = PTPLocationDto>(pTPLocationDto?: PTPLocationDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigurePtpLocations<TData = PTPLocationDto>(pTPLocationDto?: PTPLocationDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigurePtpLocations<TData = PTPLocationDto>(pTPLocationDto?: PTPLocationDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigurePtpLocations<TData = PTPLocationDto>(
    pTPLocationDto?: PTPLocationDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/ptp-locations`,
      pTPLocationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/ptp-locations`,
      pTPLocationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/ptp-locations`,
      pTPLocationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigurePtpLocations<TData = PTPLocationDto>(pTPLocationDto?: PTPLocationDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigurePtpLocations<TData = PTPLocationDto>(pTPLocationDto?: PTPLocationDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigurePtpLocations<TData = PTPLocationDto>(pTPLocationDto?: PTPLocationDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigurePtpLocations<TData = PTPLocationDto>(
    pTPLocationDto?: PTPLocationDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/ptp-locations`,
      pTPLocationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/ptp-locations`,
      pTPLocationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/ptp-locations`,
      pTPLocationDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpLocationsId<TData = PTPLocationDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpLocationsId<TData = PTPLocationDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpLocationsId<TData = PTPLocationDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpLocationsId<TData = PTPLocationDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-locations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-locations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-locations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigurePtpLocationsId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigurePtpLocationsId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigurePtpLocationsId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigurePtpLocationsId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-locations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-locations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/ptp-locations/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(
    pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/ptp-metadata-maps`,
      pTPMetaDataMapDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/ptp-metadata-maps`,
      pTPMetaDataMapDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/ptp-metadata-maps`,
      pTPMetaDataMapDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigurePtpMetadataMaps<TData = PTPMetaDataMapDto>(
    pTPMetaDataMapDto?: PTPMetaDataMapDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/ptp-metadata-maps`,
      pTPMetaDataMapDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/ptp-metadata-maps`,
      pTPMetaDataMapDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/ptp-metadata-maps`,
      pTPMetaDataMapDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpMetadataMapsOptions<TData = PTPMetaDataMapOptionsDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpMetadataMapsOptions<TData = PTPMetaDataMapOptionsDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpMetadataMapsOptions<TData = PTPMetaDataMapOptionsDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpMetadataMapsOptions<TData = PTPMetaDataMapOptionsDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps/options`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps/options`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps/options`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpMetadataMapsId<TData = PTPMetaDataMapDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpMetadataMapsId<TData = PTPMetaDataMapDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpMetadataMapsId<TData = PTPMetaDataMapDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpMetadataMapsId<TData = PTPMetaDataMapDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-metadata-maps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigurePtpMetadataMapsId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigurePtpMetadataMapsId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigurePtpMetadataMapsId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigurePtpMetadataMapsId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-metadata-maps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-metadata-maps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/ptp-metadata-maps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpSteps<TData = PTPStepConfigDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpSteps<TData = PTPStepConfigDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpSteps<TData = PTPStepConfigDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpSteps<TData = PTPStepConfigDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-steps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-steps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-steps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigurePtpSteps<TData = PTPStepConfigDto>(pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigurePtpSteps<TData = PTPStepConfigDto>(pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigurePtpSteps<TData = PTPStepConfigDto>(pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigurePtpSteps<TData = PTPStepConfigDto>(
    pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/ptp-steps`,
      pTPStepConfigDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/ptp-steps`,
      pTPStepConfigDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/ptp-steps`,
      pTPStepConfigDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigurePtpSteps<TData = PTPStepConfigDto>(pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigurePtpSteps<TData = PTPStepConfigDto>(pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigurePtpSteps<TData = PTPStepConfigDto>(pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigurePtpSteps<TData = PTPStepConfigDto>(
    pTPStepConfigDto?: PTPStepConfigDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/ptp-steps`,
      pTPStepConfigDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/ptp-steps`,
      pTPStepConfigDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/ptp-steps`,
      pTPStepConfigDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigurePtpStepsId<TData = PTPStepConfigDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigurePtpStepsId<TData = PTPStepConfigDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigurePtpStepsId<TData = PTPStepConfigDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigurePtpStepsId<TData = PTPStepConfigDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/ptp-steps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/ptp-steps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/ptp-steps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigurePtpStepsId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigurePtpStepsId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigurePtpStepsId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigurePtpStepsId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-steps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/ptp-steps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/ptp-steps/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigurePtpStepsIdReorder<TData = boolean>(id: number,
    params?: PutApiConfigurePtpStepsIdReorderParams, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigurePtpStepsIdReorder<TData = boolean>(id: number,
    params?: PutApiConfigurePtpStepsIdReorderParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigurePtpStepsIdReorder<TData = boolean>(id: number,
    params?: PutApiConfigurePtpStepsIdReorderParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigurePtpStepsIdReorder<TData = boolean>(
    id: number,
    params?: PutApiConfigurePtpStepsIdReorderParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/ptp-steps/${id}/reorder`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/ptp-steps/${id}/reorder`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.put<TData>(
      `/api/Configure/ptp-steps/${id}/reorder`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiConfigureUsersSearch<TData = UserSearchResultDto>(userPagingSearchDto?: UserPagingSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureUsersSearch<TData = UserSearchResultDto>(userPagingSearchDto?: UserPagingSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureUsersSearch<TData = UserSearchResultDto>(userPagingSearchDto?: UserPagingSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureUsersSearch<TData = UserSearchResultDto>(
    userPagingSearchDto?: UserPagingSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/users/search`,
      userPagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/users/search`,
      userPagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/users/search`,
      userPagingSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureUsersId<TData = UserDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureUsersId<TData = UserDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureUsersId<TData = UserDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureUsersId<TData = UserDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/users/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/users/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/users/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureUsersId<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureUsersId<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureUsersId<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureUsersId<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/users/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/users/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/users/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureUsers<TData = UserDto>(userDto?: UserDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureUsers<TData = UserDto>(userDto?: UserDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureUsers<TData = UserDto>(userDto?: UserDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureUsers<TData = UserDto>(
    userDto?: UserDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/users`,
      userDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/users`,
      userDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/users`,
      userDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureUsers<TData = boolean>(userDto?: UserDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureUsers<TData = boolean>(userDto?: UserDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureUsers<TData = boolean>(userDto?: UserDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureUsers<TData = boolean>(
    userDto?: UserDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/users`,
      userDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/users`,
      userDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/users`,
      userDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureUsersIdRestore<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureUsersIdRestore<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureUsersIdRestore<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureUsersIdRestore<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/users/${id}/restore`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/users/${id}/restore`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/users/${id}/restore`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureUsersIdReset2fa<TData = boolean>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureUsersIdReset2fa<TData = boolean>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureUsersIdReset2fa<TData = boolean>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureUsersIdReset2fa<TData = boolean>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/users/${id}/reset-2fa`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/users/${id}/reset-2fa`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/users/${id}/reset-2fa`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureUsersExport( options?: HttpClientBodyOptions): Observable<Blob>;
 getApiConfigureUsersExport( options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiConfigureUsersExport( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiConfigureUsersExport(
     options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Configure/users/export`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Configure/users/export`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Configure/users/export`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 postApiConfigureZonalTemplates<TData = number>(postApiConfigureZonalTemplatesBody?: PostApiConfigureZonalTemplatesBody, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureZonalTemplates<TData = number>(postApiConfigureZonalTemplatesBody?: PostApiConfigureZonalTemplatesBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureZonalTemplates<TData = number>(postApiConfigureZonalTemplatesBody?: PostApiConfigureZonalTemplatesBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureZonalTemplates<TData = number>(
    postApiConfigureZonalTemplatesBody?: PostApiConfigureZonalTemplatesBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {const formData = new FormData();
if(postApiConfigureZonalTemplatesBody?.zonalTemplateName !== undefined) {
 formData.append(`zonalTemplateName`, postApiConfigureZonalTemplatesBody.zonalTemplateName);
 }
if(postApiConfigureZonalTemplatesBody?.documentTypeId !== undefined) {
 formData.append(`documentTypeId`, postApiConfigureZonalTemplatesBody.documentTypeId.toString())
 }
if(postApiConfigureZonalTemplatesBody?.file !== undefined) {
 formData.append(`file`, postApiConfigureZonalTemplatesBody.file);
 }

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/zonal/templates`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/zonal/templates`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/zonal/templates`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureZonalTemplates<TData = ZonalTemplateListItemDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureZonalTemplates<TData = ZonalTemplateListItemDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureZonalTemplates<TData = ZonalTemplateListItemDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureZonalTemplates<TData = ZonalTemplateListItemDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/zonal/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/zonal/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/zonal/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureZonalPagesPageIdImage(pageId: number, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiConfigureZonalPagesPageIdImage(pageId: number, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiConfigureZonalPagesPageIdImage(pageId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiConfigureZonalPagesPageIdImage(
    pageId: number, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Configure/zonal/pages/${pageId}/image`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Configure/zonal/pages/${pageId}/image`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Configure/zonal/pages/${pageId}/image`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiConfigureZonalTemplatesTemplateIdPages<TData = ZonalPagesDto>(templateId: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureZonalTemplatesTemplateIdPages<TData = ZonalPagesDto>(templateId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureZonalTemplatesTemplateIdPages<TData = ZonalPagesDto>(templateId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureZonalTemplatesTemplateIdPages<TData = ZonalPagesDto>(
    templateId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/zonal/templates/${templateId}/pages`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/zonal/templates/${templateId}/pages`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/zonal/templates/${templateId}/pages`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureZonalPagesPageId<TData = ZonalPageDto>(pageId: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureZonalPagesPageId<TData = ZonalPageDto>(pageId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureZonalPagesPageId<TData = ZonalPageDto>(pageId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureZonalPagesPageId<TData = ZonalPageDto>(
    pageId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/zonal/pages/${pageId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/zonal/pages/${pageId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/zonal/pages/${pageId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureZonalPagesPageId<TData = ZonalPagesDto>(pageId: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureZonalPagesPageId<TData = ZonalPagesDto>(pageId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureZonalPagesPageId<TData = ZonalPagesDto>(pageId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureZonalPagesPageId<TData = ZonalPagesDto>(
    pageId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/zonal/pages/${pageId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/zonal/pages/${pageId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/zonal/pages/${pageId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureZonalPagesPageIdMetadata<TData = ZonalMetaDataDefinitionsDto>(pageId: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureZonalPagesPageIdMetadata<TData = ZonalMetaDataDefinitionsDto>(pageId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureZonalPagesPageIdMetadata<TData = ZonalMetaDataDefinitionsDto>(pageId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureZonalPagesPageIdMetadata<TData = ZonalMetaDataDefinitionsDto>(
    pageId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/zonal/pages/${pageId}/metadata`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/zonal/pages/${pageId}/metadata`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/zonal/pages/${pageId}/metadata`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiConfigureZonalPagesPageIdRegionsRegionId<TData = ZonalPageDto>(pageId: number,
    regionId: string, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiConfigureZonalPagesPageIdRegionsRegionId<TData = ZonalPageDto>(pageId: number,
    regionId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiConfigureZonalPagesPageIdRegionsRegionId<TData = ZonalPageDto>(pageId: number,
    regionId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiConfigureZonalPagesPageIdRegionsRegionId<TData = ZonalPageDto>(
    pageId: number,
    regionId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Configure/zonal/pages/${pageId}/regions/${regionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Configure/zonal/pages/${pageId}/regions/${regionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Configure/zonal/pages/${pageId}/regions/${regionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureZonalRegions<TData = boolean>(zonalRegionsDto?: ZonalRegionsDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureZonalRegions<TData = boolean>(zonalRegionsDto?: ZonalRegionsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureZonalRegions<TData = boolean>(zonalRegionsDto?: ZonalRegionsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureZonalRegions<TData = boolean>(
    zonalRegionsDto?: ZonalRegionsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/zonal/regions`,
      zonalRegionsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/zonal/regions`,
      zonalRegionsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/zonal/regions`,
      zonalRegionsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureZonalPages<TData = ZonalPagesDto>(postApiConfigureZonalPagesBody?: PostApiConfigureZonalPagesBody, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureZonalPages<TData = ZonalPagesDto>(postApiConfigureZonalPagesBody?: PostApiConfigureZonalPagesBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureZonalPages<TData = ZonalPagesDto>(postApiConfigureZonalPagesBody?: PostApiConfigureZonalPagesBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureZonalPages<TData = ZonalPagesDto>(
    postApiConfigureZonalPagesBody?: PostApiConfigureZonalPagesBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {const formData = new FormData();
if(postApiConfigureZonalPagesBody?.templateId !== undefined) {
 formData.append(`templateId`, postApiConfigureZonalPagesBody.templateId.toString())
 }
if(postApiConfigureZonalPagesBody?.pageNumber !== undefined) {
 formData.append(`pageNumber`, postApiConfigureZonalPagesBody.pageNumber);
 }
if(postApiConfigureZonalPagesBody?.file !== undefined) {
 formData.append(`file`, postApiConfigureZonalPagesBody.file);
 }

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/zonal/pages`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/zonal/pages`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/zonal/pages`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiConfigureZonalPages<TData = ZonalPagesDto>(editZonalPageDto?: EditZonalPageDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiConfigureZonalPages<TData = ZonalPagesDto>(editZonalPageDto?: EditZonalPageDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiConfigureZonalPages<TData = ZonalPagesDto>(editZonalPageDto?: EditZonalPageDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiConfigureZonalPages<TData = ZonalPagesDto>(
    editZonalPageDto?: EditZonalPageDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Configure/zonal/pages`,
      editZonalPageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Configure/zonal/pages`,
      editZonalPageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Configure/zonal/pages`,
      editZonalPageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConfigureZonalFailedTemplates<TData = FailedZonalTemplateListItemDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConfigureZonalFailedTemplates<TData = FailedZonalTemplateListItemDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConfigureZonalFailedTemplates<TData = FailedZonalTemplateListItemDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConfigureZonalFailedTemplates<TData = FailedZonalTemplateListItemDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Configure/zonal/failed-templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Configure/zonal/failed-templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Configure/zonal/failed-templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConfigureZonalFailedTemplate<TData = number>(failedZonalTemplateCreateDto?: FailedZonalTemplateCreateDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConfigureZonalFailedTemplate<TData = number>(failedZonalTemplateCreateDto?: FailedZonalTemplateCreateDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConfigureZonalFailedTemplate<TData = number>(failedZonalTemplateCreateDto?: FailedZonalTemplateCreateDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConfigureZonalFailedTemplate<TData = number>(
    failedZonalTemplateCreateDto?: FailedZonalTemplateCreateDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Configure/zonal/failed-template`,
      failedZonalTemplateCreateDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Configure/zonal/failed-template`,
      failedZonalTemplateCreateDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Configure/zonal/failed-template`,
      failedZonalTemplateCreateDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConnectorValidate<TData = EQValidateResultDto>(eQValidateRequest?: NonReadonly<EQValidateRequest>, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConnectorValidate<TData = EQValidateResultDto>(eQValidateRequest?: NonReadonly<EQValidateRequest>, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConnectorValidate<TData = EQValidateResultDto>(eQValidateRequest?: NonReadonly<EQValidateRequest>, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConnectorValidate<TData = EQValidateResultDto>(
    eQValidateRequest?: NonReadonly<EQValidateRequest>, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Connector/validate`,
      eQValidateRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Connector/validate`,
      eQValidateRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Connector/validate`,
      eQValidateRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiConsentForms<TData = ConsentFormDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiConsentForms<TData = ConsentFormDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiConsentForms<TData = ConsentFormDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiConsentForms<TData = ConsentFormDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Consent/forms`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Consent/forms`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Consent/forms`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiConsentAnswer<TData = UserConsentResponse>(userConsentRequest?: UserConsentRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiConsentAnswer<TData = UserConsentResponse>(userConsentRequest?: UserConsentRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiConsentAnswer<TData = UserConsentResponse>(userConsentRequest?: UserConsentRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiConsentAnswer<TData = UserConsentResponse>(
    userConsentRequest?: UserConsentRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Consent/answer`,
      userConsentRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Consent/answer`,
      userConsentRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Consent/answer`,
      userConsentRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiDocumentFileId(id: number,
    params?: GetApiDocumentFileIdParams, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiDocumentFileId(id: number,
    params?: GetApiDocumentFileIdParams, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiDocumentFileId(id: number,
    params?: GetApiDocumentFileIdParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiDocumentFileId(
    id: number,
    params?: GetApiDocumentFileIdParams, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Document/file/${id}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Document/file/${id}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Document/file/${id}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<Blob>;
  }

 getApiDocumentId<TData = DocumentDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiDocumentId<TData = DocumentDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiDocumentId<TData = DocumentDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiDocumentId<TData = DocumentDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Document/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Document/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Document/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiDocument<TData = DocumentDto>(documentDto?: DocumentDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiDocument<TData = DocumentDto>(documentDto?: DocumentDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiDocument<TData = DocumentDto>(documentDto?: DocumentDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiDocument<TData = DocumentDto>(
    documentDto?: DocumentDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Document`,
      documentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Document`,
      documentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Document`,
      documentDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiIntegrateSchema<TData = Schema>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiIntegrateSchema<TData = Schema>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiIntegrateSchema<TData = Schema>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiIntegrateSchema<TData = Schema>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Integrate/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Integrate/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Integrate/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiIntegrateSearch<TData = IntegrationSearchResponseDto>(integrationSearchDto?: IntegrationSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiIntegrateSearch<TData = IntegrationSearchResponseDto>(integrationSearchDto?: IntegrationSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiIntegrateSearch<TData = IntegrationSearchResponseDto>(integrationSearchDto?: IntegrationSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiIntegrateSearch<TData = IntegrationSearchResponseDto>(
    integrationSearchDto?: IntegrationSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Integrate/search`,
      integrationSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Integrate/search`,
      integrationSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Integrate/search`,
      integrationSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiIntegrateFileId<TData = void>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiIntegrateFileId<TData = void>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiIntegrateFileId<TData = void>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiIntegrateFileId<TData = void>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Integrate/file/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Integrate/file/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Integrate/file/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiLegacyImportSchema<TData = void>(params?: GetApiLegacyImportSchemaParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiLegacyImportSchema<TData = void>(params?: GetApiLegacyImportSchemaParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiLegacyImportSchema<TData = void>(params?: GetApiLegacyImportSchemaParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiLegacyImportSchema<TData = void>(
    params?: GetApiLegacyImportSchemaParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/LegacyImport/schema`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/LegacyImport/schema`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/LegacyImport/schema`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiSchema<TData = void>(params?: GetApiSchemaParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiSchema<TData = void>(params?: GetApiSchemaParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiSchema<TData = void>(params?: GetApiSchemaParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiSchema<TData = void>(
    params?: GetApiSchemaParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/schema`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/schema`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/schema`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiSchemaAspx<TData = void>(params?: GetApiSchemaAspxParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiSchemaAspx<TData = void>(params?: GetApiSchemaAspxParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiSchemaAspx<TData = void>(params?: GetApiSchemaAspxParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiSchemaAspx<TData = void>(
    params?: GetApiSchemaAspxParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/schema.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/schema.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/schema.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiLegacyImportSearch<TData = void>(params?: GetApiLegacyImportSearchParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiLegacyImportSearch<TData = void>(params?: GetApiLegacyImportSearchParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiLegacyImportSearch<TData = void>(params?: GetApiLegacyImportSearchParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiLegacyImportSearch<TData = void>(
    params?: GetApiLegacyImportSearchParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/LegacyImport/search`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/LegacyImport/search`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/LegacyImport/search`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiDocumentsSearch<TData = void>(params?: GetApiDocumentsSearchParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiDocumentsSearch<TData = void>(params?: GetApiDocumentsSearchParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiDocumentsSearch<TData = void>(params?: GetApiDocumentsSearchParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiDocumentsSearch<TData = void>(
    params?: GetApiDocumentsSearchParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/documents/search`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/documents/search`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/documents/search`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiDocumentsSearchAspx<TData = void>(params?: GetApiDocumentsSearchAspxParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiDocumentsSearchAspx<TData = void>(params?: GetApiDocumentsSearchAspxParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiDocumentsSearchAspx<TData = void>(params?: GetApiDocumentsSearchAspxParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiDocumentsSearchAspx<TData = void>(
    params?: GetApiDocumentsSearchAspxParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/documents/search.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/documents/search.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/documents/search.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiLegacyImportGetfile<TData = void>(params?: GetApiLegacyImportGetfileParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiLegacyImportGetfile<TData = void>(params?: GetApiLegacyImportGetfileParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiLegacyImportGetfile<TData = void>(params?: GetApiLegacyImportGetfileParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiLegacyImportGetfile<TData = void>(
    params?: GetApiLegacyImportGetfileParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/LegacyImport/getfile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/LegacyImport/getfile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/LegacyImport/getfile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiDocumentsGetfile<TData = void>(params?: GetApiDocumentsGetfileParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiDocumentsGetfile<TData = void>(params?: GetApiDocumentsGetfileParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiDocumentsGetfile<TData = void>(params?: GetApiDocumentsGetfileParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiDocumentsGetfile<TData = void>(
    params?: GetApiDocumentsGetfileParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/documents/getfile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/documents/getfile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/documents/getfile`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiDocumentsGetfileAspx<TData = void>(params?: GetApiDocumentsGetfileAspxParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiDocumentsGetfileAspx<TData = void>(params?: GetApiDocumentsGetfileAspxParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiDocumentsGetfileAspx<TData = void>(params?: GetApiDocumentsGetfileAspxParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiDocumentsGetfileAspx<TData = void>(
    params?: GetApiDocumentsGetfileAspxParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/documents/getfile.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/documents/getfile.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/documents/getfile.aspx`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiLegacyImportUpload<TData = void>(params?: PostApiLegacyImportUploadParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiLegacyImportUpload<TData = void>(params?: PostApiLegacyImportUploadParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiLegacyImportUpload<TData = void>(params?: PostApiLegacyImportUploadParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiLegacyImportUpload<TData = void>(
    params?: PostApiLegacyImportUploadParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/LegacyImport/upload`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/LegacyImport/upload`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/LegacyImport/upload`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiDocumentsUpload<TData = void>(params?: PostApiDocumentsUploadParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiDocumentsUpload<TData = void>(params?: PostApiDocumentsUploadParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiDocumentsUpload<TData = void>(params?: PostApiDocumentsUploadParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiDocumentsUpload<TData = void>(
    params?: PostApiDocumentsUploadParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/documents/upload`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/documents/upload`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/documents/upload`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiDocumentsUploadAspx<TData = void>(params?: PostApiDocumentsUploadAspxParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiDocumentsUploadAspx<TData = void>(params?: PostApiDocumentsUploadAspxParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiDocumentsUploadAspx<TData = void>(params?: PostApiDocumentsUploadAspxParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiDocumentsUploadAspx<TData = void>(
    params?: PostApiDocumentsUploadAspxParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/documents/upload.aspx`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/documents/upload.aspx`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/documents/upload.aspx`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiMigrateSearch<TData = number>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiMigrateSearch<TData = number>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiMigrateSearch<TData = number>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiMigrateSearch<TData = number>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Migrate/search`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Migrate/search`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Migrate/search`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiMonitorInfo<TData = MonitorInfoDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiMonitorInfo<TData = MonitorInfoDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiMonitorInfo<TData = MonitorInfoDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiMonitorInfo<TData = MonitorInfoDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Monitor/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Monitor/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Monitor/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiProfile<TData = ProfileResponse>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiProfile<TData = ProfileResponse>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiProfile<TData = ProfileResponse>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiProfile<TData = ProfileResponse>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Profile`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Profile`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Profile`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiProfileChangePassword<TData = void>(changePasswordRequest?: ChangePasswordRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiProfileChangePassword<TData = void>(changePasswordRequest?: ChangePasswordRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiProfileChangePassword<TData = void>(changePasswordRequest?: ChangePasswordRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiProfileChangePassword<TData = void>(
    changePasswordRequest?: ChangePasswordRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Profile/change-password`,
      changePasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Profile/change-password`,
      changePasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Profile/change-password`,
      changePasswordRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiProfileChangeEmail<TData = void>(changeEmailRequest?: ChangeEmailRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiProfileChangeEmail<TData = void>(changeEmailRequest?: ChangeEmailRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiProfileChangeEmail<TData = void>(changeEmailRequest?: ChangeEmailRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiProfileChangeEmail<TData = void>(
    changeEmailRequest?: ChangeEmailRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Profile/change-email`,
      changeEmailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Profile/change-email`,
      changeEmailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Profile/change-email`,
      changeEmailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiProfile2faValidate<TData = TotpResponse>(totpRequest?: TotpRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiProfile2faValidate<TData = TotpResponse>(totpRequest?: TotpRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiProfile2faValidate<TData = TotpResponse>(totpRequest?: TotpRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiProfile2faValidate<TData = TotpResponse>(
    totpRequest?: TotpRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Profile/2fa-validate`,
      totpRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Profile/2fa-validate`,
      totpRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Profile/2fa-validate`,
      totpRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiProfile2faToggle<TData = TotpResponse>(totpRequest?: TotpRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postApiProfile2faToggle<TData = TotpResponse>(totpRequest?: TotpRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiProfile2faToggle<TData = TotpResponse>(totpRequest?: TotpRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiProfile2faToggle<TData = TotpResponse>(
    totpRequest?: TotpRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Profile/2fa-toggle`,
      totpRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Profile/2fa-toggle`,
      totpRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Profile/2fa-toggle`,
      totpRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiProfile2faKey<TData = TotpKeyResponse>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiProfile2faKey<TData = TotpKeyResponse>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiProfile2faKey<TData = TotpKeyResponse>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiProfile2faKey<TData = TotpKeyResponse>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Profile/2fa-key`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Profile/2fa-key`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Profile/2fa-key`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiProfile2faReset<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiProfile2faReset<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiProfile2faReset<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiProfile2faReset<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Profile/2fa-reset`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Profile/2fa-reset`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Profile/2fa-reset`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetSteps<TData = PTPStepDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetSteps<TData = PTPStepDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetSteps<TData = PTPStepDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetSteps<TData = PTPStepDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetSteps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetSteps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetSteps`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetForms<TData = PTPFormDto[]>(params?: GetApiPTPGetFormsParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetForms<TData = PTPFormDto[]>(params?: GetApiPTPGetFormsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetForms<TData = PTPFormDto[]>(params?: GetApiPTPGetFormsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetForms<TData = PTPFormDto[]>(
    params?: GetApiPTPGetFormsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetForms`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetForms`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetForms`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetSearchOptions<TData = PTPStepSearchDto[]>(params?: GetApiPTPGetSearchOptionsParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetSearchOptions<TData = PTPStepSearchDto[]>(params?: GetApiPTPGetSearchOptionsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetSearchOptions<TData = PTPStepSearchDto[]>(params?: GetApiPTPGetSearchOptionsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetSearchOptions<TData = PTPStepSearchDto[]>(
    params?: GetApiPTPGetSearchOptionsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetSearchOptions`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetSearchOptions`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetSearchOptions`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetShippingLocations<TData = PTPShippingLocationDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetShippingLocations<TData = PTPShippingLocationDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetShippingLocations<TData = PTPShippingLocationDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetShippingLocations<TData = PTPShippingLocationDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetShippingLocations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetShippingLocations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetShippingLocations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetDeptsAndLocations<TData = PTPDeptsAndLocationsDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetDeptsAndLocations<TData = PTPDeptsAndLocationsDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetDeptsAndLocations<TData = PTPDeptsAndLocationsDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetDeptsAndLocations<TData = PTPDeptsAndLocationsDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetDeptsAndLocations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetDeptsAndLocations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetDeptsAndLocations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetRequesters<TData = PTPUserDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetRequesters<TData = PTPUserDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetRequesters<TData = PTPUserDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetRequesters<TData = PTPUserDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetRequesters`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetRequesters`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetRequesters`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetDepartmentChart<TData = PTPChartDataDto>(params?: GetApiPTPGetDepartmentChartParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetDepartmentChart<TData = PTPChartDataDto>(params?: GetApiPTPGetDepartmentChartParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetDepartmentChart<TData = PTPChartDataDto>(params?: GetApiPTPGetDepartmentChartParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetDepartmentChart<TData = PTPChartDataDto>(
    params?: GetApiPTPGetDepartmentChartParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetDepartmentChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetDepartmentChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetDepartmentChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetVendorChart<TData = PTPChartDataDto>(params?: GetApiPTPGetVendorChartParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetVendorChart<TData = PTPChartDataDto>(params?: GetApiPTPGetVendorChartParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetVendorChart<TData = PTPChartDataDto>(params?: GetApiPTPGetVendorChartParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetVendorChart<TData = PTPChartDataDto>(
    params?: GetApiPTPGetVendorChartParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetVendorChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetVendorChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetVendorChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetDollarsTimeChart<TData = PTPTimeChartDataDto>(params?: GetApiPTPGetDollarsTimeChartParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetDollarsTimeChart<TData = PTPTimeChartDataDto>(params?: GetApiPTPGetDollarsTimeChartParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetDollarsTimeChart<TData = PTPTimeChartDataDto>(params?: GetApiPTPGetDollarsTimeChartParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetDollarsTimeChart<TData = PTPTimeChartDataDto>(
    params?: GetApiPTPGetDollarsTimeChartParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetDollarsTimeChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetDollarsTimeChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetDollarsTimeChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetLocationChart<TData = PTPChartDataDto>(params?: GetApiPTPGetLocationChartParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetLocationChart<TData = PTPChartDataDto>(params?: GetApiPTPGetLocationChartParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetLocationChart<TData = PTPChartDataDto>(params?: GetApiPTPGetLocationChartParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetLocationChart<TData = PTPChartDataDto>(
    params?: GetApiPTPGetLocationChartParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetLocationChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetLocationChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetLocationChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetApproveChart<TData = PTPChartDataDto>(params?: GetApiPTPGetApproveChartParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetApproveChart<TData = PTPChartDataDto>(params?: GetApiPTPGetApproveChartParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetApproveChart<TData = PTPChartDataDto>(params?: GetApiPTPGetApproveChartParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetApproveChart<TData = PTPChartDataDto>(
    params?: GetApiPTPGetApproveChartParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetApproveChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetApproveChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetApproveChart`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPPOInvoiceZonalDirExists<TData = boolean>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPPOInvoiceZonalDirExists<TData = boolean>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPPOInvoiceZonalDirExists<TData = boolean>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPPOInvoiceZonalDirExists<TData = boolean>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/POInvoiceZonalDirExists`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/POInvoiceZonalDirExists`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/PTP/POInvoiceZonalDirExists`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPPOInvoice<TData = boolean>(postApiPTPPOInvoiceBody?: PostApiPTPPOInvoiceBody, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPPOInvoice<TData = boolean>(postApiPTPPOInvoiceBody?: PostApiPTPPOInvoiceBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPPOInvoice<TData = boolean>(postApiPTPPOInvoiceBody?: PostApiPTPPOInvoiceBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPPOInvoice<TData = boolean>(
    postApiPTPPOInvoiceBody?: PostApiPTPPOInvoiceBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {const formData = new FormData();
if(postApiPTPPOInvoiceBody?.file !== undefined) {
 formData.append(`file`, postApiPTPPOInvoiceBody.file);
 }

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/POInvoice`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/POInvoice`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/POInvoice`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPCreatePORequest<TData = PTPPoRequestDto>(params?: PostApiPTPCreatePORequestParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPCreatePORequest<TData = PTPPoRequestDto>(params?: PostApiPTPCreatePORequestParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPCreatePORequest<TData = PTPPoRequestDto>(params?: PostApiPTPCreatePORequestParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPCreatePORequest<TData = PTPPoRequestDto>(
    params?: PostApiPTPCreatePORequestParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/CreatePORequest`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/CreatePORequest`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/PTP/CreatePORequest`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetPORequest<TData = PTPPoRequestDto>(params?: GetApiPTPGetPORequestParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetPORequest<TData = PTPPoRequestDto>(params?: GetApiPTPGetPORequestParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetPORequest<TData = PTPPoRequestDto>(params?: GetApiPTPGetPORequestParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetPORequest<TData = PTPPoRequestDto>(
    params?: GetApiPTPGetPORequestParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetPORequest`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetPORequest`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetPORequest`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiPTPUpdatePORequest(pTPPoRequestDto?: NonReadonly<PTPPoRequestDto>, options?: HttpClientBodyOptions): Observable<string>;
 postApiPTPUpdatePORequest(pTPPoRequestDto?: NonReadonly<PTPPoRequestDto>, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiPTPUpdatePORequest(pTPPoRequestDto?: NonReadonly<PTPPoRequestDto>, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiPTPUpdatePORequest(
    pTPPoRequestDto?: NonReadonly<PTPPoRequestDto>, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/PTP/UpdatePORequest`,
      pTPPoRequestDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/PTP/UpdatePORequest`,
      pTPPoRequestDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/PTP/UpdatePORequest`,
      pTPPoRequestDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiPTPUploadPORequestAttachment(postApiPTPUploadPORequestAttachmentBody?: PostApiPTPUploadPORequestAttachmentBody, options?: HttpClientBodyOptions): Observable<string>;
 postApiPTPUploadPORequestAttachment(postApiPTPUploadPORequestAttachmentBody?: PostApiPTPUploadPORequestAttachmentBody, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiPTPUploadPORequestAttachment(postApiPTPUploadPORequestAttachmentBody?: PostApiPTPUploadPORequestAttachmentBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiPTPUploadPORequestAttachment(
    postApiPTPUploadPORequestAttachmentBody?: PostApiPTPUploadPORequestAttachmentBody, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {const formData = new FormData();
if(postApiPTPUploadPORequestAttachmentBody?.file !== undefined) {
 formData.append(`file`, postApiPTPUploadPORequestAttachmentBody.file);
 }
if(postApiPTPUploadPORequestAttachmentBody?.poRequestId !== undefined) {
 formData.append(`poRequestId`, postApiPTPUploadPORequestAttachmentBody.poRequestId.toString())
 }
if(postApiPTPUploadPORequestAttachmentBody?.fileName !== undefined) {
 formData.append(`fileName`, postApiPTPUploadPORequestAttachmentBody.fileName);
 }
if(postApiPTPUploadPORequestAttachmentBody?.fileDescription !== undefined) {
 formData.append(`fileDescription`, postApiPTPUploadPORequestAttachmentBody.fileDescription);
 }

    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/PTP/UploadPORequestAttachment`,
      formData,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/PTP/UploadPORequestAttachment`,
      formData,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/PTP/UploadPORequestAttachment`,
      formData,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 getApiPTPGetPORequestAttachment(params?: GetApiPTPGetPORequestAttachmentParams, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiPTPGetPORequestAttachment(params?: GetApiPTPGetPORequestAttachmentParams, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiPTPGetPORequestAttachment(params?: GetApiPTPGetPORequestAttachmentParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiPTPGetPORequestAttachment(
    params?: GetApiPTPGetPORequestAttachmentParams, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get(
      `/api/PTP/GetPORequestAttachment`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/PTP/GetPORequestAttachment`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/PTP/GetPORequestAttachment`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<Blob>;
  }

 getApiPTPDeletePORequestAttachment(params?: GetApiPTPDeletePORequestAttachmentParams, options?: HttpClientBodyOptions): Observable<string>;
 getApiPTPDeletePORequestAttachment(params?: GetApiPTPDeletePORequestAttachmentParams, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 getApiPTPDeletePORequestAttachment(params?: GetApiPTPDeletePORequestAttachmentParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  getApiPTPDeletePORequestAttachment(
    params?: GetApiPTPDeletePORequestAttachmentParams, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<string>(
      `/api/PTP/DeletePORequestAttachment`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<string>(
      `/api/PTP/DeletePORequestAttachment`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<string>(
      `/api/PTP/DeletePORequestAttachment`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiPTPCreatePO<TData = PTPPoDto>(params?: PostApiPTPCreatePOParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPCreatePO<TData = PTPPoDto>(params?: PostApiPTPCreatePOParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPCreatePO<TData = PTPPoDto>(params?: PostApiPTPCreatePOParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPCreatePO<TData = PTPPoDto>(
    params?: PostApiPTPCreatePOParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/CreatePO`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/CreatePO`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/PTP/CreatePO`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiPTPGetPO<TData = PTPPoDto>(params?: GetApiPTPGetPOParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetPO<TData = PTPPoDto>(params?: GetApiPTPGetPOParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetPO<TData = PTPPoDto>(params?: GetApiPTPGetPOParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetPO<TData = PTPPoDto>(
    params?: GetApiPTPGetPOParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetPO`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetPO`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetPO`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiPTPUpdatePO<TData = PTPPoDto>(pTPPoDto?: NonReadonly<PTPPoDto>, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPUpdatePO<TData = PTPPoDto>(pTPPoDto?: NonReadonly<PTPPoDto>, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPUpdatePO<TData = PTPPoDto>(pTPPoDto?: NonReadonly<PTPPoDto>, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPUpdatePO<TData = PTPPoDto>(
    pTPPoDto?: NonReadonly<PTPPoDto>, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/UpdatePO`,
      pTPPoDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/UpdatePO`,
      pTPPoDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/UpdatePO`,
      pTPPoDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetOrderMonitor<TData = PTPPoOrderMonitor>(params?: GetApiPTPGetOrderMonitorParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetOrderMonitor<TData = PTPPoOrderMonitor>(params?: GetApiPTPGetOrderMonitorParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetOrderMonitor<TData = PTPPoOrderMonitor>(params?: GetApiPTPGetOrderMonitorParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetOrderMonitor<TData = PTPPoOrderMonitor>(
    params?: GetApiPTPGetOrderMonitorParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetOrderMonitor`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetOrderMonitor`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetOrderMonitor`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiPTPUpdateOrderMonitor<TData = PTPPoOrderMonitor>(pTPPoOrderMonitor?: PTPPoOrderMonitor, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPUpdateOrderMonitor<TData = PTPPoOrderMonitor>(pTPPoOrderMonitor?: PTPPoOrderMonitor, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPUpdateOrderMonitor<TData = PTPPoOrderMonitor>(pTPPoOrderMonitor?: PTPPoOrderMonitor, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPUpdateOrderMonitor<TData = PTPPoOrderMonitor>(
    pTPPoOrderMonitor?: PTPPoOrderMonitor, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/UpdateOrderMonitor`,
      pTPPoOrderMonitor,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/UpdateOrderMonitor`,
      pTPPoOrderMonitor,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/UpdateOrderMonitor`,
      pTPPoOrderMonitor,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetGoodsReceipt<TData = PTPPoGoodsReceipt>(params?: GetApiPTPGetGoodsReceiptParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetGoodsReceipt<TData = PTPPoGoodsReceipt>(params?: GetApiPTPGetGoodsReceiptParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetGoodsReceipt<TData = PTPPoGoodsReceipt>(params?: GetApiPTPGetGoodsReceiptParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetGoodsReceipt<TData = PTPPoGoodsReceipt>(
    params?: GetApiPTPGetGoodsReceiptParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetGoodsReceipt`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetGoodsReceipt`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetGoodsReceipt`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiPTPUpdateGoodsReceipt<TData = PTPPoGoodsReceipt>(pTPPoGoodsReceipt?: PTPPoGoodsReceipt, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPUpdateGoodsReceipt<TData = PTPPoGoodsReceipt>(pTPPoGoodsReceipt?: PTPPoGoodsReceipt, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPUpdateGoodsReceipt<TData = PTPPoGoodsReceipt>(pTPPoGoodsReceipt?: PTPPoGoodsReceipt, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPUpdateGoodsReceipt<TData = PTPPoGoodsReceipt>(
    pTPPoGoodsReceipt?: PTPPoGoodsReceipt, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/UpdateGoodsReceipt`,
      pTPPoGoodsReceipt,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/UpdateGoodsReceipt`,
      pTPPoGoodsReceipt,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/UpdateGoodsReceipt`,
      pTPPoGoodsReceipt,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiPTPGetPayment<TData = PTPPoPaymentDto>(params?: GetApiPTPGetPaymentParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiPTPGetPayment<TData = PTPPoPaymentDto>(params?: GetApiPTPGetPaymentParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiPTPGetPayment<TData = PTPPoPaymentDto>(params?: GetApiPTPGetPaymentParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiPTPGetPayment<TData = PTPPoPaymentDto>(
    params?: GetApiPTPGetPaymentParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/PTP/GetPayment`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/PTP/GetPayment`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/PTP/GetPayment`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 postApiPTPUpdatePayment(pTPPoPaymentDto?: PTPPoPaymentDto, options?: HttpClientBodyOptions): Observable<string>;
 postApiPTPUpdatePayment(pTPPoPaymentDto?: PTPPoPaymentDto, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiPTPUpdatePayment(pTPPoPaymentDto?: PTPPoPaymentDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiPTPUpdatePayment(
    pTPPoPaymentDto?: PTPPoPaymentDto, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/PTP/UpdatePayment`,
      pTPPoPaymentDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/PTP/UpdatePayment`,
      pTPPoPaymentDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/PTP/UpdatePayment`,
      pTPPoPaymentDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiPTPSearch<TData = PTPStepQueryResultDto>(pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPSearch<TData = PTPStepQueryResultDto>(pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPSearch<TData = PTPStepQueryResultDto>(pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPSearch<TData = PTPStepQueryResultDto>(
    pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/Search`,
      pTPStepQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/Search`,
      pTPStepQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/Search`,
      pTPStepQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPExport(pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientBodyOptions): Observable<Blob>;
 postApiPTPExport(pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 postApiPTPExport(pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  postApiPTPExport(
    pTPStepQueryDto?: PTPStepQueryDto, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.post(
      `/api/PTP/Export`,
      pTPStepQueryDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/PTP/Export`,
      pTPStepQueryDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.post(
      `/api/PTP/Export`,
      pTPStepQueryDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 postApiPTPApprove<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPApprove<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPApprove<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPApprove<TData = PTPTransactionResultDto>(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/Approve`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/Approve`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/Approve`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPDeny<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPDeny<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPDeny<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPDeny<TData = PTPTransactionResultDto>(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/Deny`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/Deny`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/Deny`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPCancel<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPCancel<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPCancel<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPCancel<TData = PTPTransactionResultDto>(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/Cancel`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/Cancel`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/Cancel`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPRestore<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiPTPRestore<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiPTPRestore<TData = PTPTransactionResultDto>(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiPTPRestore<TData = PTPTransactionResultDto>(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/PTP/Restore`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/PTP/Restore`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/PTP/Restore`,
      pTPTransactionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiPTPDeletePO(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<string>;
 postApiPTPDeletePO(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiPTPDeletePO(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiPTPDeletePO(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/PTP/DeletePO`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/PTP/DeletePO`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/PTP/DeletePO`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiPTPDeletePR(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<string>;
 postApiPTPDeletePR(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiPTPDeletePR(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiPTPDeletePR(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/PTP/DeletePR`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/PTP/DeletePR`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/PTP/DeletePR`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiPTPApplyChecks(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientBodyOptions): Observable<string>;
 postApiPTPApplyChecks(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiPTPApplyChecks(pTPTransactionDto?: PTPTransactionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiPTPApplyChecks(
    pTPTransactionDto?: PTPTransactionDto, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/PTP/ApplyChecks`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/PTP/ApplyChecks`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/PTP/ApplyChecks`,
      pTPTransactionDto,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 getApiReportArInfo<TData = ARReportInfoDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportArInfo<TData = ARReportInfoDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportArInfo<TData = ARReportInfoDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportArInfo<TData = ARReportInfoDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/ar/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/ar/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/ar/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportArCustomersSearch<TData = ARReportCustomerSearchResultDto>(aRReportCustomerSearchDto?: ARReportCustomerSearchDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiReportArCustomersSearch<TData = ARReportCustomerSearchResultDto>(aRReportCustomerSearchDto?: ARReportCustomerSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiReportArCustomersSearch<TData = ARReportCustomerSearchResultDto>(aRReportCustomerSearchDto?: ARReportCustomerSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiReportArCustomersSearch<TData = ARReportCustomerSearchResultDto>(
    aRReportCustomerSearchDto?: ARReportCustomerSearchDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Report/ar/customers/search`,
      aRReportCustomerSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Report/ar/customers/search`,
      aRReportCustomerSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Report/ar/customers/search`,
      aRReportCustomerSearchDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiReportArCustomersId<TData = ARReportCustomerDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportArCustomersId<TData = ARReportCustomerDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportArCustomersId<TData = ARReportCustomerDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportArCustomersId<TData = ARReportCustomerDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/ar/customers/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/ar/customers/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/ar/customers/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiReportArCustomersId<TData = void>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiReportArCustomersId<TData = void>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiReportArCustomersId<TData = void>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiReportArCustomersId<TData = void>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Report/ar/customers/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Report/ar/customers/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Report/ar/customers/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportArCustomers<TData = ARReportCustomerDto>(aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiReportArCustomers<TData = ARReportCustomerDto>(aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiReportArCustomers<TData = ARReportCustomerDto>(aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiReportArCustomers<TData = ARReportCustomerDto>(
    aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Report/ar/customers`,
      aRReportCustomerDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Report/ar/customers`,
      aRReportCustomerDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Report/ar/customers`,
      aRReportCustomerDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiReportArCustomers<TData = ARReportCustomerDto>(aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiReportArCustomers<TData = ARReportCustomerDto>(aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiReportArCustomers<TData = ARReportCustomerDto>(aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiReportArCustomers<TData = ARReportCustomerDto>(
    aRReportCustomerDto?: ARReportCustomerDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Report/ar/customers`,
      aRReportCustomerDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Report/ar/customers`,
      aRReportCustomerDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Report/ar/customers`,
      aRReportCustomerDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportArCustomersExport(aRReportCustomerExportSearchDto?: ARReportCustomerExportSearchDto, options?: HttpClientBodyOptions): Observable<Blob>;
 postApiReportArCustomersExport(aRReportCustomerExportSearchDto?: ARReportCustomerExportSearchDto, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 postApiReportArCustomersExport(aRReportCustomerExportSearchDto?: ARReportCustomerExportSearchDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  postApiReportArCustomersExport(
    aRReportCustomerExportSearchDto?: ARReportCustomerExportSearchDto, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.post(
      `/api/Report/ar/customers/export`,
      aRReportCustomerExportSearchDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/Report/ar/customers/export`,
      aRReportCustomerExportSearchDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.post(
      `/api/Report/ar/customers/export`,
      aRReportCustomerExportSearchDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiReportFinStatus<TData = FINReportStatusDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportFinStatus<TData = FINReportStatusDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportFinStatus<TData = FINReportStatusDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportFinStatus<TData = FINReportStatusDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/fin/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/fin/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/fin/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiReportArStatus<TData = ARReportStatusDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportArStatus<TData = ARReportStatusDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportArStatus<TData = ARReportStatusDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportArStatus<TData = ARReportStatusDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/ar/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/ar/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/ar/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiReportFinInfo<TData = FINReportInfoDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportFinInfo<TData = FINReportInfoDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportFinInfo<TData = FINReportInfoDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportFinInfo<TData = FINReportInfoDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/fin/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/fin/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/fin/info`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportFinCustomers(fINAddCustomerRequest?: FINAddCustomerRequest, options?: HttpClientBodyOptions): Observable<string>;
 postApiReportFinCustomers(fINAddCustomerRequest?: FINAddCustomerRequest, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiReportFinCustomers(fINAddCustomerRequest?: FINAddCustomerRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiReportFinCustomers(
    fINAddCustomerRequest?: FINAddCustomerRequest, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/Report/fin/customers`,
      fINAddCustomerRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/Report/fin/customers`,
      fINAddCustomerRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/Report/fin/customers`,
      fINAddCustomerRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiReportFinCustomersDelete(fINRemoveCustomerRequest?: FINRemoveCustomerRequest, options?: HttpClientBodyOptions): Observable<string>;
 postApiReportFinCustomersDelete(fINRemoveCustomerRequest?: FINRemoveCustomerRequest, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiReportFinCustomersDelete(fINRemoveCustomerRequest?: FINRemoveCustomerRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiReportFinCustomersDelete(
    fINRemoveCustomerRequest?: FINRemoveCustomerRequest, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/Report/fin/customers/delete`,
      fINRemoveCustomerRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/Report/fin/customers/delete`,
      fINRemoveCustomerRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/Report/fin/customers/delete`,
      fINRemoveCustomerRequest,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiReportFinJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiReportFinJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiReportFinJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiReportFinJobs<TData = JobsListDto>(
    jobQueryDto?: JobQueryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Report/fin/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Report/fin/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Report/fin/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportArJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiReportArJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiReportArJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiReportArJobs<TData = JobsListDto>(
    jobQueryDto?: JobQueryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Report/ar/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Report/ar/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Report/ar/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiReportFinJobsJobGuidLogs<TData = ReportJobLogDto[]>(jobGuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportFinJobsJobGuidLogs<TData = ReportJobLogDto[]>(jobGuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportFinJobsJobGuidLogs<TData = ReportJobLogDto[]>(jobGuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportFinJobsJobGuidLogs<TData = ReportJobLogDto[]>(
    jobGuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/fin/jobs/${jobGuid}/logs`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/fin/jobs/${jobGuid}/logs`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/fin/jobs/${jobGuid}/logs`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiReportArJobsJobGuidLogs<TData = ReportJobLogDto[]>(jobGuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 getApiReportArJobsJobGuidLogs<TData = ReportJobLogDto[]>(jobGuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiReportArJobsJobGuidLogs<TData = ReportJobLogDto[]>(jobGuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiReportArJobsJobGuidLogs<TData = ReportJobLogDto[]>(
    jobGuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Report/ar/jobs/${jobGuid}/logs`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Report/ar/jobs/${jobGuid}/logs`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Report/ar/jobs/${jobGuid}/logs`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiReportFinJobsJobGuidLogsLogIdFile(jobGuid: string,
    logId: number, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiReportFinJobsJobGuidLogsLogIdFile(jobGuid: string,
    logId: number, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiReportFinJobsJobGuidLogsLogIdFile(jobGuid: string,
    logId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiReportFinJobsJobGuidLogsLogIdFile(
    jobGuid: string,
    logId: number, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Report/fin/jobs/${jobGuid}/logs/${logId}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Report/fin/jobs/${jobGuid}/logs/${logId}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Report/fin/jobs/${jobGuid}/logs/${logId}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiReportArJobsJobGuidLogsLogIdFile(jobGuid: string,
    logId: number, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiReportArJobsJobGuidLogsLogIdFile(jobGuid: string,
    logId: number, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiReportArJobsJobGuidLogsLogIdFile(jobGuid: string,
    logId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiReportArJobsJobGuidLogsLogIdFile(
    jobGuid: string,
    logId: number, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Report/ar/jobs/${jobGuid}/logs/${logId}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Report/ar/jobs/${jobGuid}/logs/${logId}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Report/ar/jobs/${jobGuid}/logs/${logId}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiReportFinJobsJobGuidFile(jobGuid: string, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiReportFinJobsJobGuidFile(jobGuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiReportFinJobsJobGuidFile(jobGuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiReportFinJobsJobGuidFile(
    jobGuid: string, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Report/fin/jobs/${jobGuid}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Report/fin/jobs/${jobGuid}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Report/fin/jobs/${jobGuid}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiReportArJobsJobGuidFile(jobGuid: string, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiReportArJobsJobGuidFile(jobGuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiReportArJobsJobGuidFile(jobGuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiReportArJobsJobGuidFile(
    jobGuid: string, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Report/ar/jobs/${jobGuid}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Report/ar/jobs/${jobGuid}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Report/ar/jobs/${jobGuid}/file`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 deleteApiReportFinJobsJobGuid<TData = void>(jobGuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiReportFinJobsJobGuid<TData = void>(jobGuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiReportFinJobsJobGuid<TData = void>(jobGuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiReportFinJobsJobGuid<TData = void>(
    jobGuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Report/fin/jobs/${jobGuid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Report/fin/jobs/${jobGuid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Report/fin/jobs/${jobGuid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiReportArJobsJobGuid<TData = void>(jobGuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiReportArJobsJobGuid<TData = void>(jobGuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiReportArJobsJobGuid<TData = void>(jobGuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiReportArJobsJobGuid<TData = void>(
    jobGuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Report/ar/jobs/${jobGuid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Report/ar/jobs/${jobGuid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Report/ar/jobs/${jobGuid}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportFinRun<TData = JobCreateResponse>(fINReportJobParams?: FINReportJobParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiReportFinRun<TData = JobCreateResponse>(fINReportJobParams?: FINReportJobParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiReportFinRun<TData = JobCreateResponse>(fINReportJobParams?: FINReportJobParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiReportFinRun<TData = JobCreateResponse>(
    fINReportJobParams?: FINReportJobParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Report/fin/run`,
      fINReportJobParams,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Report/fin/run`,
      fINReportJobParams,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Report/fin/run`,
      fINReportJobParams,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiReportArRun<TData = JobCreateResponse>(aRReportJobParams?: ARReportJobParams, options?: HttpClientBodyOptions): Observable<TData>;
 postApiReportArRun<TData = JobCreateResponse>(aRReportJobParams?: ARReportJobParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiReportArRun<TData = JobCreateResponse>(aRReportJobParams?: ARReportJobParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiReportArRun<TData = JobCreateResponse>(
    aRReportJobParams?: ARReportJobParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Report/ar/run`,
      aRReportJobParams,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Report/ar/run`,
      aRReportJobParams,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Report/ar/run`,
      aRReportJobParams,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanJobs<TData = JobsListDto>(jobQueryDto?: JobQueryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanJobs<TData = JobsListDto>(
    jobQueryDto?: JobQueryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Scan/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Scan/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Scan/jobs`,
      jobQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanScans<TData = ScanResultsDto>(scanQueryDto?: ScanQueryDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanScans<TData = ScanResultsDto>(scanQueryDto?: ScanQueryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanScans<TData = ScanResultsDto>(scanQueryDto?: ScanQueryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanScans<TData = ScanResultsDto>(
    scanQueryDto?: ScanQueryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Scan/scans`,
      scanQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Scan/scans`,
      scanQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Scan/scans`,
      scanQueryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiScanScanId(scanId: number, options?: HttpClientBodyOptions): Observable<string>;
 deleteApiScanScanId(scanId: number, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 deleteApiScanScanId(scanId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  deleteApiScanScanId(
    scanId: number, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.delete<string>(
      `/api/Scan/${scanId}`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<string>(
      `/api/Scan/${scanId}`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.delete<string>(
      `/api/Scan/${scanId}`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiScanScanIdUnlock(scanId: number, options?: HttpClientBodyOptions): Observable<string>;
 postApiScanScanIdUnlock(scanId: number, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postApiScanScanIdUnlock(scanId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postApiScanScanIdUnlock(
    scanId: number, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.post<string>(
      `/api/Scan/${scanId}/unlock`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<string>(
      `/api/Scan/${scanId}/unlock`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.post<string>(
      `/api/Scan/${scanId}/unlock`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 getApiScanLogFileJobId(jobId: number, options?: HttpClientBodyOptions): Observable<Blob>;
 getApiScanLogFileJobId(jobId: number, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getApiScanLogFileJobId(jobId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getApiScanLogFileJobId(
    jobId: number, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/Scan/log-file/${jobId}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/Scan/log-file/${jobId}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/Scan/log-file/${jobId}`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiScanImage(accept: 'image/jpeg',
    params?: GetApiScanImageParams, options?: HttpClientOptions): Observable<Blob>;
  getApiScanImage(accept: 'image/tiff',
    params?: GetApiScanImageParams, options?: HttpClientOptions): Observable<Blob>;
  getApiScanImage(accept?: GetApiScanImageAccept,
    params?: GetApiScanImageParams, options?: HttpClientOptions): Observable<unknown | Blob>;
  getApiScanImage(
    accept: GetApiScanImageAccept = 'image/jpeg',
    params?: GetApiScanImageParams,
    options?: HttpClientOptions
  ): Observable<unknown | Blob> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    const headers = options?.headers instanceof HttpHeaders
      ? options.headers.set('Accept', accept)
      : { ...(options?.headers ?? {}), Accept: accept };

    if (accept.includes('json') || accept.includes('+json')) {
      return this.http.get<unknown>(`/api/Scan/image`, {
        ...options,
        responseType: 'json',
        headers,
        params: filteredParams,

      });
    } else if (accept.startsWith('text/') || accept.includes('xml')) {
      return this.http.get(`/api/Scan/image`, {
        ...options,
        responseType: 'text',
        headers,
        params: filteredParams,

      }) as Observable<any>;
    } else {
      return this.http.get(`/api/Scan/image`, {
        ...options,
        responseType: 'blob',
        headers,
        params: filteredParams,

      }) as Observable<Blob>;
    }
  }

 getApiScanDirectory<TData = ScanDirectoryDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiScanDirectory<TData = ScanDirectoryDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiScanDirectory<TData = ScanDirectoryDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiScanDirectory<TData = ScanDirectoryDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/ScanDirectory`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/ScanDirectory`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/ScanDirectory`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanDirectory<TData = ScanDirectoryDto>(scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanDirectory<TData = ScanDirectoryDto>(scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanDirectory<TData = ScanDirectoryDto>(scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanDirectory<TData = ScanDirectoryDto>(
    scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/ScanDirectory`,
      scanDirectoryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/ScanDirectory`,
      scanDirectoryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/ScanDirectory`,
      scanDirectoryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiScanDirectory<TData = void>(scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiScanDirectory<TData = void>(scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiScanDirectory<TData = void>(scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiScanDirectory<TData = void>(
    scanDirectoryDto?: ScanDirectoryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/ScanDirectory`,
      scanDirectoryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/ScanDirectory`,
      scanDirectoryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/ScanDirectory`,
      scanDirectoryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiScanDirectoryId<TData = ScanDirectoryDto>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiScanDirectoryId<TData = ScanDirectoryDto>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiScanDirectoryId<TData = ScanDirectoryDto>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiScanDirectoryId<TData = ScanDirectoryDto>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/ScanDirectory/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/ScanDirectory/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/ScanDirectory/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiScanDirectoryId<TData = void>(id: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiScanDirectoryId<TData = void>(id: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiScanDirectoryId<TData = void>(id: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiScanDirectoryId<TData = void>(
    id: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/ScanDirectory/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/ScanDirectory/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/ScanDirectory/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiScanDirectorySchema<TData = Schema>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiScanDirectorySchema<TData = Schema>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiScanDirectorySchema<TData = Schema>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiScanDirectorySchema<TData = Schema>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/ScanDirectory/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/ScanDirectory/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/ScanDirectory/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiScanProcessSummary<TData = ScanProcessDto>(params?: GetApiScanProcessSummaryParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiScanProcessSummary<TData = ScanProcessDto>(params?: GetApiScanProcessSummaryParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiScanProcessSummary<TData = ScanProcessDto>(params?: GetApiScanProcessSummaryParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiScanProcessSummary<TData = ScanProcessDto>(
    params?: GetApiScanProcessSummaryParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/ScanProcess/summary`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/ScanProcess/summary`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/ScanProcess/summary`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 getApiScanProcessMetadata<TData = ScanProcessMetadataDto>(params?: GetApiScanProcessMetadataParams, options?: HttpClientBodyOptions): Observable<TData>;
 getApiScanProcessMetadata<TData = ScanProcessMetadataDto>(params?: GetApiScanProcessMetadataParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiScanProcessMetadata<TData = ScanProcessMetadataDto>(params?: GetApiScanProcessMetadataParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiScanProcessMetadata<TData = ScanProcessMetadataDto>(
    params?: GetApiScanProcessMetadataParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/ScanProcess/metadata`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/ScanProcess/metadata`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/ScanProcess/metadata`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 putApiScanProcessMetadata<TData = void>(scanProcessUpdateMetadataDto?: ScanProcessUpdateMetadataDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiScanProcessMetadata<TData = void>(scanProcessUpdateMetadataDto?: ScanProcessUpdateMetadataDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiScanProcessMetadata<TData = void>(scanProcessUpdateMetadataDto?: ScanProcessUpdateMetadataDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiScanProcessMetadata<TData = void>(
    scanProcessUpdateMetadataDto?: ScanProcessUpdateMetadataDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/ScanProcess/metadata`,
      scanProcessUpdateMetadataDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/ScanProcess/metadata`,
      scanProcessUpdateMetadataDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/ScanProcess/metadata`,
      scanProcessUpdateMetadataDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiScanProcessSelect<TData = void>(scanPageIdDto?: ScanPageIdDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiScanProcessSelect<TData = void>(scanPageIdDto?: ScanPageIdDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiScanProcessSelect<TData = void>(scanPageIdDto?: ScanPageIdDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiScanProcessSelect<TData = void>(
    scanPageIdDto?: ScanPageIdDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/ScanProcess/select`,
      scanPageIdDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/ScanProcess/select`,
      scanPageIdDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/ScanProcess/select`,
      scanPageIdDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanProcessUpdatePage<TData = void>(scanProcessUpdatePageDto?: ScanProcessUpdatePageDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanProcessUpdatePage<TData = void>(scanProcessUpdatePageDto?: ScanProcessUpdatePageDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanProcessUpdatePage<TData = void>(scanProcessUpdatePageDto?: ScanProcessUpdatePageDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanProcessUpdatePage<TData = void>(
    scanProcessUpdatePageDto?: ScanProcessUpdatePageDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/ScanProcess/update-page`,
      scanProcessUpdatePageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/ScanProcess/update-page`,
      scanProcessUpdatePageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/ScanProcess/update-page`,
      scanProcessUpdatePageDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiScanProcessDeletePage<TData = void>(scanPageIdDto?: ScanPageIdDto, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiScanProcessDeletePage<TData = void>(scanPageIdDto?: ScanPageIdDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiScanProcessDeletePage<TData = void>(scanPageIdDto?: ScanPageIdDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiScanProcessDeletePage<TData = void>(
    scanPageIdDto?: ScanPageIdDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/ScanProcess/delete-page`,{body: scanPageIdDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/ScanProcess/delete-page`,{body: scanPageIdDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/api/ScanProcess/delete-page`,{body: scanPageIdDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }

 postApiScanProcessRotate<TData = void>(scanProcessRotateRequestDto?: ScanProcessRotateRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanProcessRotate<TData = void>(scanProcessRotateRequestDto?: ScanProcessRotateRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanProcessRotate<TData = void>(scanProcessRotateRequestDto?: ScanProcessRotateRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanProcessRotate<TData = void>(
    scanProcessRotateRequestDto?: ScanProcessRotateRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/ScanProcess/rotate`,
      scanProcessRotateRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/ScanProcess/rotate`,
      scanProcessRotateRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/ScanProcess/rotate`,
      scanProcessRotateRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanProcessRegion<TData = ScanProcessRegionResponseDto>(scanProcessRegionRequestDto?: ScanProcessRegionRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanProcessRegion<TData = ScanProcessRegionResponseDto>(scanProcessRegionRequestDto?: ScanProcessRegionRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanProcessRegion<TData = ScanProcessRegionResponseDto>(scanProcessRegionRequestDto?: ScanProcessRegionRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanProcessRegion<TData = ScanProcessRegionResponseDto>(
    scanProcessRegionRequestDto?: ScanProcessRegionRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/ScanProcess/region`,
      scanProcessRegionRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/ScanProcess/region`,
      scanProcessRegionRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/ScanProcess/region`,
      scanProcessRegionRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanProcessReprocess<TData = void>(scanReprocessDto?: ScanReprocessDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanProcessReprocess<TData = void>(scanReprocessDto?: ScanReprocessDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanProcessReprocess<TData = void>(scanReprocessDto?: ScanReprocessDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanProcessReprocess<TData = void>(
    scanReprocessDto?: ScanReprocessDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/ScanProcess/reprocess`,
      scanReprocessDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/ScanProcess/reprocess`,
      scanReprocessDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/ScanProcess/reprocess`,
      scanReprocessDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiScanProcessFinalize<TData = void>(scanProcessFinalizeDto?: ScanProcessFinalizeDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiScanProcessFinalize<TData = void>(scanProcessFinalizeDto?: ScanProcessFinalizeDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiScanProcessFinalize<TData = void>(scanProcessFinalizeDto?: ScanProcessFinalizeDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiScanProcessFinalize<TData = void>(
    scanProcessFinalizeDto?: ScanProcessFinalizeDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/ScanProcess/finalize`,
      scanProcessFinalizeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/ScanProcess/finalize`,
      scanProcessFinalizeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/ScanProcess/finalize`,
      scanProcessFinalizeDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiSearchSearch<TData = SearchResponseDto>(searchRequestDto?: SearchRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiSearchSearch<TData = SearchResponseDto>(searchRequestDto?: SearchRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiSearchSearch<TData = SearchResponseDto>(searchRequestDto?: SearchRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiSearchSearch<TData = SearchResponseDto>(
    searchRequestDto?: SearchRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Search/search`,
      searchRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Search/search`,
      searchRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Search/search`,
      searchRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiSearchExport(bulkRequestDto?: BulkRequestDto, options?: HttpClientBodyOptions): Observable<Blob>;
 postApiSearchExport(bulkRequestDto?: BulkRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 postApiSearchExport(bulkRequestDto?: BulkRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  postApiSearchExport(
    bulkRequestDto?: BulkRequestDto, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.post(
      `/api/Search/export`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/Search/export`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.post(
      `/api/Search/export`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 postApiSearchZip(bulkRequestDto?: BulkRequestDto, options?: HttpClientBodyOptions): Observable<Blob>;
 postApiSearchZip(bulkRequestDto?: BulkRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 postApiSearchZip(bulkRequestDto?: BulkRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  postApiSearchZip(
    bulkRequestDto?: BulkRequestDto, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.post(
      `/api/Search/zip`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/Search/zip`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.post(
      `/api/Search/zip`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 deleteApiSearchDelete<TData = void>(bulkRequestDto?: BulkRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiSearchDelete<TData = void>(bulkRequestDto?: BulkRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiSearchDelete<TData = void>(bulkRequestDto?: BulkRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiSearchDelete<TData = void>(
    bulkRequestDto?: BulkRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Search/delete`,{body: bulkRequestDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Search/delete`,{body: bulkRequestDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/api/Search/delete`,{body: bulkRequestDto,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }

 postApiSearchEmail<TData = void>(bulkRequestDto?: BulkRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiSearchEmail<TData = void>(bulkRequestDto?: BulkRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiSearchEmail<TData = void>(bulkRequestDto?: BulkRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiSearchEmail<TData = void>(
    bulkRequestDto?: BulkRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Search/email`,
      bulkRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Search/email`,
      bulkRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Search/email`,
      bulkRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiSearchPrint(bulkRequestDto?: BulkRequestDto, options?: HttpClientBodyOptions): Observable<Blob>;
 postApiSearchPrint(bulkRequestDto?: BulkRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 postApiSearchPrint(bulkRequestDto?: BulkRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  postApiSearchPrint(
    bulkRequestDto?: BulkRequestDto, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.post(
      `/api/Search/print`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/Search/print`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.post(
      `/api/Search/print`,
      bulkRequestDto,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }

 getApiSearchSearches<TData = SaveSearchRequestDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiSearchSearches<TData = SaveSearchRequestDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiSearchSearches<TData = SaveSearchRequestDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiSearchSearches<TData = SaveSearchRequestDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Search/searches`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Search/searches`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Search/searches`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiSearchSearches<TData = void>(saveSearchRequestDto?: SaveSearchRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 postApiSearchSearches<TData = void>(saveSearchRequestDto?: SaveSearchRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiSearchSearches<TData = void>(saveSearchRequestDto?: SaveSearchRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiSearchSearches<TData = void>(
    saveSearchRequestDto?: SaveSearchRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Search/searches`,
      saveSearchRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Search/searches`,
      saveSearchRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Search/searches`,
      saveSearchRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 deleteApiSearchSearchesSearchId<TData = void>(searchId: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteApiSearchSearchesSearchId<TData = void>(searchId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteApiSearchSearchesSearchId<TData = void>(searchId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteApiSearchSearchesSearchId<TData = void>(
    searchId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/Search/searches/${searchId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/Search/searches/${searchId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/Search/searches/${searchId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiSystemSchema<TData = SchemaDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiSystemSchema<TData = SchemaDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiSystemSchema<TData = SchemaDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiSystemSchema<TData = SchemaDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/System/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/System/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/System/schema`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiSystemModules<TData = ModuleDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiSystemModules<TData = ModuleDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiSystemModules<TData = ModuleDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiSystemModules<TData = ModuleDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/System/modules`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/System/modules`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/System/modules`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiSystemVersion( options?: HttpClientBodyOptions): Observable<string>;
 getApiSystemVersion( options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 getApiSystemVersion( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  getApiSystemVersion(
     options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    if (options?.observe === 'events') {
      return this.http.get<string>(
      `/api/System/version`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<string>(
      `/api/System/version`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    );
    }

    return this.http.get<string>(
      `/api/System/version`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    );
  }

 postApiTenantDxSettings<TData = DXSettingsDto>( options?: HttpClientBodyOptions): Observable<TData>;
 postApiTenantDxSettings<TData = DXSettingsDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiTenantDxSettings<TData = DXSettingsDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiTenantDxSettings<TData = DXSettingsDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Tenant/dx-settings`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Tenant/dx-settings`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Tenant/dx-settings`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 putApiTenantDxSettings<TData = void>(dXSettingsDto?: DXSettingsDto, options?: HttpClientBodyOptions): Observable<TData>;
 putApiTenantDxSettings<TData = void>(dXSettingsDto?: DXSettingsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putApiTenantDxSettings<TData = void>(dXSettingsDto?: DXSettingsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putApiTenantDxSettings<TData = void>(
    dXSettingsDto?: DXSettingsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/Tenant/dx-settings`,
      dXSettingsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/Tenant/dx-settings`,
      dXSettingsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/api/Tenant/dx-settings`,
      dXSettingsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiUploadPurchaseOrderMetadataPoId<TData = GetApiUploadPurchaseOrderMetadataPoId200>(poId: number, options?: HttpClientBodyOptions): Observable<TData>;
 getApiUploadPurchaseOrderMetadataPoId<TData = GetApiUploadPurchaseOrderMetadataPoId200>(poId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiUploadPurchaseOrderMetadataPoId<TData = GetApiUploadPurchaseOrderMetadataPoId200>(poId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiUploadPurchaseOrderMetadataPoId<TData = GetApiUploadPurchaseOrderMetadataPoId200>(
    poId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Upload/purchase-order-metadata/${poId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Upload/purchase-order-metadata/${poId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Upload/purchase-order-metadata/${poId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 getApiUploadP2pDocumentType<TData = InternalSettingDto>( options?: HttpClientBodyOptions): Observable<TData>;
 getApiUploadP2pDocumentType<TData = InternalSettingDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getApiUploadP2pDocumentType<TData = InternalSettingDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getApiUploadP2pDocumentType<TData = InternalSettingDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/Upload/p2p-document-type`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/Upload/p2p-document-type`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/Upload/p2p-document-type`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

 postApiUploadDocument<TData = UploadResultDto>(postApiUploadDocumentBody?: PostApiUploadDocumentBody, options?: HttpClientBodyOptions): Observable<TData>;
 postApiUploadDocument<TData = UploadResultDto>(postApiUploadDocumentBody?: PostApiUploadDocumentBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postApiUploadDocument<TData = UploadResultDto>(postApiUploadDocumentBody?: PostApiUploadDocumentBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postApiUploadDocument<TData = UploadResultDto>(
    postApiUploadDocumentBody?: PostApiUploadDocumentBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {const formData = new FormData();
if(postApiUploadDocumentBody?.file !== undefined) {
 formData.append(`file`, postApiUploadDocumentBody.file);
 }
if(postApiUploadDocumentBody?.DocumentType !== undefined) {
 formData.append(`DocumentType`, postApiUploadDocumentBody.DocumentType.toString())
 }
if(postApiUploadDocumentBody?.PoId !== undefined) {
 formData.append(`PoId`, postApiUploadDocumentBody.PoId.toString())
 }
if(postApiUploadDocumentBody?.Keywords !== undefined) {
 postApiUploadDocumentBody?.Keywords.forEach((value, index) => {
    if(value?.MetaDataDefinitionID !== undefined) {
 formData.append(`Keywords[${index}].MetaDataDefinitionID`, value.MetaDataDefinitionID.toString())
 }
if(value?.KeywordType !== undefined) {
 formData.append(`Keywords[${index}].KeywordType`, value.KeywordType.toString())
 }
if(value?.Value !== undefined && value.Value !== null) {
 formData.append(`Keywords[${index}].Value`, value.Value);
 }
});
 }

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/Upload/document`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/Upload/document`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/Upload/document`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

};
